import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import "../CodingScreen/CodingScreen.css";
import confirm_tick from "../../common/assets/images/confirm.png";
import code_assist from "../../common/assets/images/codebook.png";
import { toast } from "react-toastify";
import { Loader } from "../../utils/Loader";
import { CodeContext } from "../pages/Coder/Coder";
import { debounce } from "lodash";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import code_assist_seacrh from "../../common/assets/images/search-1.png";
import stars_icon from "../../common/assets/images/stars-01.png";
import { acceptCode, checkHAC, codeReccomendations } from "./Service";
import { getErrorMessage } from "./utils";
import DraggableItem from "./DraggableItem";
import { useLazyGetData2Query } from "../../store/apiSlice";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Warnings from "./Warnings";
import DrgInfo from "./DrgInfo";
import WarningModal from "./WarningModal";
import VentilationInfo from "./VentilationInfo";
import {
  setActiveIcon,
  setActiveTab,
  setRawSearchQuery,
  updateAcsCode,
} from "../CodeBook/redux/CodeBookSlicer";
import { Box, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import {
  getFilterEpisodeLists,
  selectedEpisodeList,
} from "../pages/EpisodeList/redux/EpisodeListSlicer";
import {
  resetIsPallasAlgoApplied,
  setClusterIDs,
  setcurrentClusterID,
  setDocumentationCard,
  setRangeChildren,
} from "../pages/Coder/redux/CoderSlicer";
import axiosInstance from "../../axiosinterceptor";
import WarningStack from "./WarningStack/WarningStack";
import DotsLoader from "../../utils/DotsLoader";
import { Placeholder } from "react-bootstrap";

const CodingScreen = ({
  drgData,
  setDrgData,
  selectedVersion,
  setSelectedVersion,
  codingscreendata,
  episodeListData,
  setCodeBookCard,
  setReimbursementValue,
  setAccepted,
  diagnosisStates,
  setDiagnosisStates,
  setTrackHistory,
  setRedoStack,
  setShowCodeSearch,
  skipAcceptApi,
  acceptedCodes,
  setAcceptedCodes,
  calculate_drg,
  handleConfirmDrg,
  drgConfirmedStatusUpdate,
  isDrgConfirmed,
  setEnableFinalize,
  enableFinalize,
  setAuditedStatus,
  auditedStatus,
  handleCodeAssistAdding,
  validateCodeAPI,
  insertCode,
  handleAccept,
  saveToHistory,
  iconDisplay,
  setIconDispaly,
  warningMessage,
  setWarningMessage,
  newlyInsertedCodes,
  setNewlyInsertedCodes,
  pendingCode,
  pendingType,
  setPendingCode,
  setPendingType,
  modalVisible,
  isCheckingWarnings,
  setModalVisible,
  modalMessage,
  setModalMessage,
  nextClusterCurrentIndex,
  currentStatus,
  mvHours,
  setMvHours,
  handleMvhoursupdation,
  deletedCodes,
  setDeletedCodes,
  triggerWarnings,
  hasDenyConfirmation,
  selectedActionType,
  setSelectedActionType,
  isBatchInsertingRef,
  batchInsertCompleted,
  setBatchInsertCompleted,
  showCodeSearch,
  hasCofOrClusterChanged,
  setHasCofOrClusterChanged,
  setShowMyActionsDropdown
  // isLockedCoder
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isLockedCoder = codingscreendata?.data?.meta?.is_locked;
  const {
    setSelectedCodeBookCode,
    setSelectedTabKeyCoding,
    setDrgLoading,
    drgloading,
  } = useContext(CodeContext);
  const [enteredCode, setEnteredCode] = useState({
    principalCode: "",
    additionalCode: "",
    procedureCode: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    principal: "",
    additional: "",
    procedure: "",
  });
  // const [stopDropCall,setStopDrop]=useState(false);
  const [searchBy, setSearchBy] = useState("");
  // const dispatch = useDispatch();
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;

  const codebookinternalEnv = process.env.REACT_APP_FLAG_INTERNAL;
  const codebooknmhsEnv = process.env.REACT_APP_FLAG_NMHS;

  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
  const pallasaiTestCodebookEnv = process.env.REACT_APP_FLAG_PALLASAI_TEST;
  const codebookfigiEnv = process.env.REACT_APP_FLAG_FIJI_DEV;
  const codebooksanhcEnv = process.env.REACT_APP_FLAG_SAN_HC;
  const codebooksanprodEnv = process.env.REACT_APP_FLAG_SAN_PROD;
  const { selectedQueueworkSpace } = useSelector((state) => state.episodeList);
  const [codeValidationisLoading, setIsCodeValidationLoading] = useState(false);
  const { drgSelectedVersion, selectedDrgData } = useSelector(
    (state) => state.episodeStatus,
  );
  const isDCID = codingscreendata?.data?.meta?.is_DCID === true;
  const skipAcceptOnStateChange = useRef(false);
  const isSuppressedRef = useRef(false);
  const hasPrincipalError = diagnosisStates?.principal?.some(
    (item) =>
      item?.warning?.is_warning === true &&
      item?.warning?.warning_description
        ?.toLowerCase()
        .includes("invalid/unacceptable principal diagnosis"),
  );
  // console.log(hasDenyConfirmation,'hasDenyConfirmation');
  
  const lastCodedEpisode = useSelector((state) => state.episodeList);

  const typeOfPatient = lastCodedEpisode?.selectedEpisode?.type_patient;
  const { drgValue, weightValue, accepted } = useContext(CodeContext);
  // const [newlyInsertedCodes, setNewlyInsertedCodes] = useState([]);
  const [searchOptionsDropdown, setSearchOptionsDropdown] = useState(false);
  // const diagnosisStates = useSelector(
  //   (state) => state.codingScreen.diagnosisStates
  // );

  const {
    icd10amTabularData13,
    icd10amIndexData13,
    achiIndexData13,
    achiTabularData13,
    codePathHistory,
    codeBookLoading,
    selectedCodebookVersion,
    isFetched12,
    isFetched13,
  } = useSelector((state) => ({
    ...state.codeBook,
    codePathHistory: state.codeSearch?.codePathHistory || [],
  }));

  const {
    currentClusterID,
    injuryWithActivity,
    externalCauseCodes,
    placeOfOccurrence,
    activityCodes,
    injuryWithoutActivity,
    chronicCodes,
  } = useSelector((state) => state.coder);
  const { clusterCodeWarningsIsLoading, clusterCodeWarningsWarningList } =
    useSelector((state) => state.coder.clusterCodeWarnings);

  const finalcode = sessionStorage.getItem("finalCode");
  const isLastHCPLineIDPresent = sessionStorage.getItem("last_hcp_line_id");

  // const [modalVisible, setModalVisible] = useState(false);
  // const [modalMessage, setModalMessage] = useState("");
  // const [pendingCode, setPendingCode] = useState(null);
  // const [pendingType, setPendingType] = useState(null);
  // const [warningMessage, setWarningMessage] = useState();
  const [hacStatus, setHACStatus] = useState({});
  const [hasCode, setHasCode] = useState(false);
  const [
    fetchData1,
    {
      data: data1,
      isLoading: isLoading1,
      isFetching: isFetching1,
      error: error1,
    },
  ] = useLazyGetData2Query();
  const [skipAPI, setSkipAPI] = useState(false);
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  // const [iconDisplay, setIconDispaly] = useState(true);
  const [isAnimation, setIsAnimation] = useState(false);
  const [recommendations, setRecommendations] = useState([]);
  const [lastHcpLineId, setHcpLineId] = useState(
    sessionStorage.getItem("last_hcp_line_id"),
  );
  const navigate = useNavigate();
  let controller = new AbortController();
  const [hasPrincipalHAC, setHasPrincipalHAC] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const location = useLocation();
  const fromLocation = location.state?.from;
  const isFromAccelerate = location.state?.fromAccelerate;
  const dropdownRef = useRef(null);
  const inputRefList = useRef({});
  const searchOptionsRef = useRef(null);
  const isOutPatient = typeOfPatient === "outPatient";
  const queueType = location.state?.queue_type;
  const queueID = location.state?.queue_id;
  const currentPage = sessionStorage.getItem("currentPage");
  const allCodes = isOutPatient
    ? [...(codingscreendata?.data?.procedure_codes || [])]
    : [
        ...(codingscreendata?.data?.procedure_codes || []),
        ...(codingscreendata?.data?.additional_diagnoses || []),
        ...(codingscreendata?.data?.principal_diagnosis || []),
      ];


  // Filter only AI-origin codes
  const aiCodes = isOutPatient
  ? [...(diagnosisStates?.procedure || [])]
  : [
      ...(diagnosisStates?.procedure || []),
      ...(diagnosisStates?.additional || []),
      ...(diagnosisStates?.principal || []),
    ].filter((code) => code?.origin === "AI");
    
    // const allOriginsAreAU = allCodes.every((item) => item.origin === "AU");
    
    // Check if all AI-origin codes are accepted
    const allCodesAccepted =
    aiCodes.length > 0 &&
    aiCodes.every((code) => !!(acceptedCodes?.[code.code.trim()] ?? false));
    console.log('check ai codes',aiCodes,allCodesAccepted,externalCauseCodes);
  const targetStatuses = ["Coding Complete", "Audited","For Review","Audit - For Review","On Hold","Audit - On Hold"];

  const hasTargetStatus = codingscreendata?.data?.meta?.status?.some((s) =>
    targetStatuses.includes(s.status),
  );
  const isGlobalConditionMet =
    hasTargetStatus ||
    codingscreendata?.data?.additional_diagnoses?.length === 0 ||
    codingscreendata?.data?.principal_diagnosis?.[0]?.code === null ||
    codingscreendata?.data?.procedure_codes?.length === 0;
  const allOriginsAreU =
    isGlobalConditionMet ||
    allCodes.every(
      (item) =>
        item.origin === "U" || item.origin === "AU" || item.origin === "P",
    );
  const [selectedCofValues, setSelectedCofValues] = useState({});
  const isButtonEnabled = allCodesAccepted;
  // Add this once above return
  // console.log(
  //   codingscreendata?.data?.additional_diagnoses?.length > 0,
  //   codingscreendata?.data?.principal_diagnosis?.[0]?.code != null,
  //   codingscreendata?.data?.procedure_codes?.length > 0,
  //   selectedActionType,
  //   "checkConditions",
  // );

  const isActionRestricted =
    (codingscreendata?.data?.additional_diagnoses?.length > 0 ||
      codingscreendata?.data?.principal_diagnosis?.[0]?.code != null ||
      codingscreendata?.data?.procedure_codes?.length > 0) &&
    newlyInsertedCodes.length === 0 && // only restrict if DRG is already done
    (selectedActionType === "forReview");
    const allSectionsEmpty =
  (diagnosisStates?.principal?.length === 0 ||
    diagnosisStates?.principal?.every((item) => !item?.code)) &&
  diagnosisStates?.additional?.length === 0 &&
  diagnosisStates?.procedure?.length === 0;
  // Add this after your existing conditions (around line where you have other conditions)
  //   console.log(allOriginsAreU,isButtonEnabled,isActionRestricted,newlyInsertedCodes,selectedActionType, "allOriginsAreU");
  //   console.log(
  //   "additional empty:", codingscreendata?.data?.additional_diagnoses?.length === 0,
  //   "principal null:", codingscreendata?.data?.principal_diagnosis?.[0]?.code === null,
  //   "procedure empty:", codingscreendata?.data?.procedure_codes?.length === 0,
  //   "newlyInserted:", newlyInsertedCodes.length
  // );
const checkCofWarnings = (codingscreendata) => {
  if (!codingscreendata || !codingscreendata.data) return;

  const { principal_diagnosis, additional_diagnoses, procedure_codes } =
    codingscreendata.data;
  const allCodes = [
    ...(principal_diagnosis || []),
    ...(additional_diagnoses || []),
    ...(procedure_codes || []),
  ];

  let hasCofWarning = false;
  const updatedHacStatus = {};

  allCodes.forEach((item) => {
    if (item?.cof_warning === true && item?.code) {
      hasCofWarning = true;
      // Normalize: strip leading digit prefix (1 or 2) to get base code
      const normalizedCode = item.code.replace(/^[12]/, "");
      updatedHacStatus[normalizedCode] = true;
    }
  });

  setHACStatus(updatedHacStatus);
  setHasCode(hasCofWarning);
};

  // useEffect(() => {
  //   if (diagnosisStates?.procedure?.length > 0) {
  //     const updatedProcedure = [...diagnosisStates.procedure];

  //     const itemsToMove = [];
  //     const remainingItems = [];

  //     updatedProcedure.forEach((item) => {
  //       const rawCode = item.code;
  //       const cleanCode = rawCode.split("[")[0].trim();

  //       if (predefinedProcedureCodes.includes(cleanCode)) {
  //         itemsToMove.push(item);
  //       } else {
  //         remainingItems.push(item);
  //       }
  //     });

  //     const reorderedProcedure = [...remainingItems, ...itemsToMove];

  //     // Avoid infinite loop — only update if something changed
  //     const codesBefore = updatedProcedure.map((i) => i.code).join(",");
  //     const codesAfter = reorderedProcedure.map((i) => i.code).join(",");

  //     if (codesBefore !== codesAfter) {
  //       setDiagnosisStates((prev) => ({
  //         ...prev,
  //         procedure: reorderedProcedure,
  //       }));
  //     }
  //   }
  // }, [diagnosisStates.procedure]);

  const fetchRecommendations = useCallback(
    debounce(async (payload) => {
      if (
        (payload.code && !payload.code.trim()) ||
        (payload.description && !payload.description.trim())
      ) {
        setRecommendations([]);
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      setIsLoading(true);
      try {
        const response = await codeReccomendations(payload, controller.signal);
        if (response) {
          setRecommendations(response.data);
          setShowDropdown(true);
        }
      } catch (error) {
        console.error("Error fetching recommendations:", error);
      } finally {
        setIsLoading(false);
      }
    }, 100),
    [],
  );

  const handleCodeChange = (e, type, searchBy) => {

    const finalCodeKey = searchBy === "Code" ? "code" : "description";
    const { name, value } = e.target;

    setActiveSection(type);
    setEnteredCode((prev) => ({ ...prev, [name]: value }));

    if (value.trim() === "") {
      setActiveSection(null);
      setErrorMessage((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    // Determine coding system
    let checkType;
    if (type === "additional" || type === "principal") {
      checkType = "ICD";
    } else if (
      (checkType =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        codebooksanprodEnv ||
        pallasaiTestCodebookEnv ||
        codebooksanhcEnv ||
        codebookfigiEnv)
    ) {
      checkType = "ACHI";
    } else if (codebookusaEnv) {
      // USA-specific logic
      if (typeOfPatient === "inPatient") {
        checkType = "PCS"; // Inpatient → PCS
      } else {
        checkType = "CPT"; // Outpatient / default → CPT
      }
    } else {
      checkType = "";
    }

    // Dynamically construct payload with key `code` or `description`
    const payload = {
      [finalCodeKey]: value,
      check_for: checkType,
      similarity: false,
      type_patient: typeOfPatient || "none",
    };

    fetchRecommendations(payload);
  };

  // const validateCodeAPI = async (code, type) => {
  //   if (type === "additional" || type === "principal") {
  //     type = "ICD";
  //   } else {
  //     type =
  //       codebookdevEnv ||
  //       codebookinternalEnv ||
  //       codebookcoblhEnv ||
  //       codebooknmhsEnv ||
  //       codebooksanEnv||pallasaiTestCodebookEnv || codebookfigiEnv
  //         ? "ACHI"
  //         : codebookusaEnv
  //         ? "CPT"
  //         : "";
  //   }
  //   const url = "/checkIfCodeExists";
  //   const payload = {
  //     u_agey: codingscreendata?.data?.meta?.age_y,
  //     u_aged: codingscreendata?.data?.meta?.age_d,
  //     sex: codingscreendata?.data?.meta?.sex,
  //     code: code,
  //     check_for: type,
  //   };
  //   try {
  //     const response = await axiosInstance.post(url, payload);
  //     if (response.status === 200) {
  //       return {
  //         valid: response.data.code_exists,
  //         description: response.data.description || "",
  //         isWarning: response.data.is_warning || false,
  //         warningDescription: response.data.warning_description || "",
  //         isPopup: response.data.should_popup,
  //       };
  //     }
  //   } catch (error) {
  //     console.error("Error validating code", error);
  //   }
  //   return {
  //     valid: false,
  //     description: "",
  //     isWarning: false,
  //     warningDescription: "",
  //     isPopup: "",
  //   };
  // };

  const insertingCodes = new Set();
  // const insertCode = async (code, description, type, warning) => {
  //   if (insertingCodes.has(code)) {
  //     // console.warn(`Skipping duplicate insertion for: ${code}`);
  //     return;
  //   }
  //   insertingCodes.add(code);
  //   return new Promise((resolve) => {
  //     setDiagnosisStates((prev) => {
  //       if (prev[type].some((item) => item.code === code)) {
  //         insertingCodes.delete(code);
  //         //console.warn(`Code already exists in ${type}, skipping: ${code}`);
  //         return prev;
  //       }
  //       const newCode = {
  //         code,
  //         description: description || `Description for ${code}`,
  //         warning,
  //       };
  //       const updatedState = {
  //         ...prev,
  //         [type]: type === "principal" ? [newCode] : [...prev[type], newCode],
  //       };
  //       sessionStorage.setItem(
  //         `${type}DiagnosisState`,
  //         JSON.stringify(updatedState[type])
  //       );
  //       return updatedState;
  //     });
  //     setTimeout(() => {
  //       setDiagnosisStates((updatedState) => {
  //         handleAccept(code, { code, description, warning }, type, updatedState)
  //           .then(() => insertingCodes.delete(code))
  //           .catch(() => insertingCodes.delete(code));
  //         return updatedState;
  //       });
  //       resolve();
  //     }, 0);
  //   });
  // };
  // const saveToHistory = () => {
  //   setTrackHistory((prev) => [
  //     ...prev,
  //     cloneDeep({ diagnosisStates, acceptedCodes }),
  //   ]);
  //   setRedoStack([]);
  // };

  const isCodeRestricted = (code) => {
    return /^M.*\/\d$/.test(code);
  };

  const checkTypeOfCode = (code) => {
    // console.log(code, 'code')
    if (!code) return "";

    const removeFirstChar = code?.slice(1);
    let result = "";

    const injuryWithActivityCodes =
      injuryWithActivity?.map((v) => v?.name) ?? [];

    const externalCauseCodesList =
      externalCauseCodes?.map((v) => v?.name) ?? [];

    const placeOfOccurrenceCodes = placeOfOccurrence?.map((v) => v?.name) ?? [];

    const activityCodesList = activityCodes?.map((v) => v?.name) ?? [];

    const injuryWithoutActivityCodes =
      injuryWithoutActivity?.map((v) => v?.name) ?? [];

    const chronicCodesList = chronicCodes?.map((v) => v?.name) ?? [];

    const allNonChronicGroups = [
      injuryWithActivityCodes,
      externalCauseCodesList,
      placeOfOccurrenceCodes,
      activityCodesList,
      injuryWithoutActivityCodes,
    ];

    const isNonChronic = allNonChronicGroups.some((list) =>
      list.includes(code),
    );

    if (isNonChronic) {
      result = `${currentClusterID}${code}`;
    } else if (chronicCodesList.includes(code)) {
      result = `0${code}`;
    } else {
      result = `8${code}`;
    }
    console.log(result, 'resssssss', currentClusterID)
    return result;
  };
  const handleCodeInsertionUSA = async (inputValue, type) => {
    setActiveSection(null);
    setIsAnimation(true);
    setAuditedStatus(true);
    try {
      if (!inputValue || (Array.isArray(inputValue) && inputValue.length === 0))
        return;
      if (Array.isArray(inputValue)) {
        inputValue = inputValue.join(", ");
      }

      const isSpecialPattern = inputValue.trim().startsWith("(");

      let extractedCodes = [];

      const match = inputValue.trim().match(/^\(([^)]+)\)([^,]+)(?:,(.+))?$/);
      if (match) {
        const codeInsideParens = match[1].trim();
        const firstCode = match[2].trim();
        const remainingCodes = match[3]
          ? match[3]
              .split(",")
              .map((c) => c.trim())
              .filter(Boolean)
          : [];

        extractedCodes = [firstCode, codeInsideParens, ...remainingCodes];
      } else {
        extractedCodes = inputValue
          .split(",")
          .map((code) => code.trim())
          .filter(Boolean);
      }

      // Remove duplicates
      extractedCodes = [...new Set(extractedCodes)];
      if (extractedCodes.length === 0) return;

      // **Filter out restricted codes here**
      const filteredCodes = extractedCodes.filter((code) => {
        if (isCodeRestricted(code)) {
          // toast.warning(`Code ${code} is not allowed.`);
          return false;
        }
        return true;
      });

      if (filteredCodes.length === 0) {
        toast.warning("No valid codes to insert!");
        return;
      }

      let principalCode = filteredCodes[0];
      let additionalCodes = filteredCodes.slice(1);
      let prevPrincipal = diagnosisStates["principal"][0];

      const existingCodes = new Set([
        ...diagnosisStates["principal"].map((item) =>
          item?.code?.replace(/^[12]/, ""),
        ),
        ...diagnosisStates["additional"].map((item) =>
          item?.code?.replace(/^[12]/, ""),
        ),
        ...diagnosisStates["procedure"].map((item) =>
          item?.code?.replace(/^[12]/, ""),
        ),
      ]);

      let validCodes = [];
      let principalWarnings = [];
      let additionalWarnings = [];

      const validationResults = await Promise.all(
        filteredCodes.map(async (code) => {
          const validationType =
            type === "procedure"
              ? "procedure"
              : code === principalCode && type === "principal"
                ? "principal"
                : "additional";

          const {
            valid,
            description,
            isWarning,
            warningDescription,
            isPopup,
            acs,
          } = await validateCodeAPI(code, validationType);

          if (!valid) return null;

          const warning = {
            is_warning: isWarning,
            should_popup: isPopup,
            warning_description: warningDescription,
          };

          if (isWarning && warningDescription) {
            if (validationType === "principal") {
              principalWarnings.push(warningDescription);
            } else {
              additionalWarnings.push(warningDescription);
            }
          }

          return { code, description, warning, validationType, acs };
        }),
      );

      validCodes = validationResults.filter(Boolean);
      if (validCodes.length === 0) {
        toast.warning("No valid new codes to insert!");
        return;
      }
      const removeFirstChar = (codeSet) => {
        const newSet = new Set();
        for (const code of codeSet) {
          if (typeof code === "string" && code.length > 1) {
            newSet.add(code.slice(1));
          }
        }
        return newSet;
      };
      const cleanUPCodesWithoutFirstChar =
        type === "procedure" ? existingCodes : removeFirstChar(existingCodes);

      const newValidCodes = validCodes.filter(({ code }) => {
        const normalizedCode = code;

        if (cleanUPCodesWithoutFirstChar.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });

      if (newValidCodes.length === 0) {
        // toast.warning("No new codes to insert after checking existing codes!");
        return;
      }

      saveToHistory();
      const orderedValidCodes =
        type === "principal" ? [...newValidCodes].reverse() : newValidCodes;

      setDiagnosisStates((prevStates) => {
        let updatedStates = {
          principal: [...prevStates["principal"]],
          additional: [...prevStates["additional"]],
          procedure: [...prevStates["procedure"]],
        };

        if (type === "principal") {
          const principalEntry = newValidCodes.find(
            ({ code }) =>
              code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, ""),
          );

          if (
            prevPrincipal?.code &&
            principalEntry &&
            prevPrincipal?.code?.replace(/^[12]/, "") !==
              principalEntry?.code?.replace(/^[12]/, "") &&
            !updatedStates["additional"].some(
              (item) =>
                item?.code?.replace(/^[12]/, "") ===
                prevPrincipal?.code?.replace(/^[12]/, ""),
            )
          ) {
            updatedStates["additional"] = [
              prevPrincipal,
              ...updatedStates["additional"],
            ];
          }

          if (principalEntry) {
            updatedStates["principal"] = [
              { ...principalEntry, code: `Y${principalEntry.code}` },
            ];
          }
        }

        orderedValidCodes.forEach(
          ({ code, description, warning, validationType, acs }) => {
            const normalizedCode = code.replace(/^[12]/, "");
            const alreadyExistsInAdditional = updatedStates["additional"].some(
              (item) => item?.code?.replace(/^[12]/, "") === normalizedCode,
            );
            const alreadyExistsInPrincipal = updatedStates["principal"].some(
              (item) => item?.code?.replace(/^[12]/, "") === normalizedCode,
            );

            if (!alreadyExistsInAdditional && !alreadyExistsInPrincipal) {
              const prefixedCode =
                validationType !== "procedure" ? `Y${code}` : code;
              insertCode(prefixedCode, description, validationType, warning);
              const newEntry = {
                code: prefixedCode,
                description,
                warning,
                acs,
              };

              if (validationType === "additional") {
                if (type === "principal") {
                  updatedStates["additional"].unshift(newEntry);
                } else {
                  updatedStates["additional"].push(newEntry);
                }
              }
            }
          },
        );

        return updatedStates;
      });

      setWarningMessage((prevWarnings) => {
        let updatedWarnings = [...prevWarnings];
        const currentPrincipalWarnings = new Set(
          (diagnosisStates?.principal || [])
            .filter((item) => item?.warning?.is_warning)
            .map((item) => item?.warning?.warning_description),
        );

        const currentAdditionalWarnings = new Set(
          diagnosisStates["additional"]
            .filter((item) => item.warning?.is_warning)
            .map((item) => item.warning.warning_description),
        );

        // Preserve COF warnings - don't filter them out
        updatedWarnings = updatedWarnings.filter(
          (msg) =>
            // Keep if it's a COF warning
            msg.includes("has COF") ||
            // OR if it's in current warnings
            currentPrincipalWarnings.has(msg) ||
            currentAdditionalWarnings.has(msg),
        );

        principalWarnings.forEach((warning) => {
          if (!updatedWarnings.includes(warning)) {
            updatedWarnings.unshift(warning);
          }
        });

        additionalWarnings.forEach((warning) => {
          if (!updatedWarnings.includes(warning)) {
            updatedWarnings.push(warning);
          }
        });

        return updatedWarnings;
      });

      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...newValidCodes.map(({ code }) => code),
      ]);

      const lastInsertedCode = newValidCodes[newValidCodes.length - 1]?.code;
      const popupWarning = newValidCodes.find(
        ({ code, warning }) =>
          code === lastInsertedCode && warning.should_popup,
      );

      if (popupWarning) {
        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(popupWarning.warning.warning_description);
        setModalVisible(true);
      }

      setEnteredCode((prev) => ({ ...prev, [type]: "" }));
    } catch (error) {
      console.log(error);
    } finally {
      setIsAnimation(false);
      // setAuditedStatus(false);
      const newEpisodeListFilterObj = sessionStorage.getItem("filters");
      const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
      // setTimeout(() => {
      //   dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {

      //     const newEpisodeRecord = res.payload?.episode?.find(
      //       (episode) => episode?.hcp_line_id === Number(hcpLineId),
      //     );

      //     if (newEpisodeRecord) {
      //       dispatch(selectedEpisodeList(newEpisodeRecord));
      //     }
      //   });
      // }, 300);
    }
  };

  const handleCodeInsertion = async (inputValue, type) => {
    if (isLockedCoder) {
      toast.error("Episode is locked.");
      return;
    }
    setActiveSection(null);
    setIsAnimation(true);
    setAuditedStatus(true);
    try {
      if (!inputValue || (Array.isArray(inputValue) && inputValue.length === 0))
        return;
      if (Array.isArray(inputValue)) {
        inputValue = inputValue.join(", ");
      }

      const isSpecialPattern = inputValue.trim().startsWith("(");

      let extractedCodes = [];

      const match = inputValue.trim().match(/^\(([^)]+)\)([^,]+)(?:,(.+))?$/);
      if (match) {
        const codeInsideParens = match[1].trim();
        const firstCode = match[2].trim();
        const remainingCodes = match[3]
          ? match[3]
              .split(",")
              .map((c) => c.trim())
              .filter(Boolean)
          : [];

        extractedCodes = [firstCode, codeInsideParens, ...remainingCodes];
      } else {
        extractedCodes = inputValue
          .split(",")
          .map((code) => code.trim())
          .filter(Boolean);
      }
      if (extractedCodes.length >= 2) {
        const [first, second, ...rest] = extractedCodes;
        extractedCodes = [second, first, ...rest];
      }

      // Remove duplicates
      extractedCodes = [...new Set(extractedCodes)];
      if (extractedCodes.length === 0) return;

      // **Filter out restricted codes here**
      const filteredCodes = extractedCodes.filter((code) => {
        if (
          type === "principal" &&
          isCodeRestricted(code) &&
          extractedCodes.length === 1
        ) {
          // toast.warning(`Code ${code} is not allowed.`);
          return false;
        }
        return true;
      });

      if (filteredCodes.length === 0) {
        toast.warning("No valid codes to insert!");
        return;
      }

      let principalCode = filteredCodes[0];
      let additionalCodes = filteredCodes.slice(1);
      let prevPrincipal = diagnosisStates["principal"][0];
      // console.log(diagnosisStates,'ksjdjsbh');
      
      const existingCodes = new Set([
        ...diagnosisStates["principal"].map((item) =>
          item?.code?.replace(/[./]/g, ""),
        ),
        ...diagnosisStates["additional"].map((item) =>
          item?.code?.replace(/[./]/g, ""),
        ),
        ...diagnosisStates["procedure"].map((item) => item?.code),
      ]);
      // console.log(existingCodes,'asdfdsfrfc');
      

      let validCodes = [];
      let principalWarnings = [];
      let additionalWarnings = [];

      setIsCodeValidationLoading(true);

      let validationResults;

      try {
        validationResults = await Promise.all(
          filteredCodes.map(async (code) => {
            const validationType =
              type === "procedure"
                ? "procedure"
                : code === principalCode && type === "principal"
                  ? "principal"
                  : "additional";

            const {
              valid,
              validCode,
              description,
              isWarning,
              warningDescription,
              isPopup,
              acs,
              nca
            } = await validateCodeAPI(code, validationType);

            if (!valid) return null;

            const warning = {
              is_warning: isWarning,
              should_popup: isPopup,
              warning_description: warningDescription,
            };

            if (isWarning && warningDescription) {
              if (validationType === "principal") {
                principalWarnings.push(warningDescription);
              } else {
                additionalWarnings.push(warningDescription);
              }
            }

            return { validCode, description, warning, validationType, acs, nca };
          }),
        );
      } finally {
        setIsCodeValidationLoading(false);
      }

      validCodes = validationResults.filter(Boolean);
      if (validCodes.length === 0) {
        toast.warning("No valid new codes to insert!");
        return;
      }

      const newValidCodes = validCodes?.filter(({ validCode }) => {
        // const normalizedCode = code.replace(/^[12]/, "");
        const normalizedCode = !codebookusaEnv
          ? validCode?.replace(/^[0128]/, "").replace(/[./]/g, "")
          : validCode?.replace(/^[12]/, "").replace(/[./]/g, "");

           const removeLeadingDigits = (codeSet,type) => {
        // console.log(codeSet,'codesetnew');
        
        return new Set(
          [...codeSet]
            ?.filter((c) => typeof c === "string" && c?.length > 0)
            ?.map((code) => {
              if(type === 'procedure'){
                return code;
              }
              if (/^[A-Za-z]/.test(code)) {
                return code;
              }
              return code?.replace(/^\d+/, "");
            }),
        );
      };

      const cleanUPCodes = removeLeadingDigits(existingCodes,type);
        // console.log(cleanUPCodes,normalizeCode, "existing codes set");
        if (cleanUPCodes?.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });

      if (newValidCodes?.length === 0) {
        // toast.warning("No new codes to insert after checking existing codes!");
        return;
      }
      saveToHistory();
      const orderedValidCodes =
        type === "principal" ? [...newValidCodes].reverse() : newValidCodes;
      let updatedStateRef = null;
      const lastValidCode = newValidCodes[newValidCodes.length - 1];
const lastCode = (() => {
  if (!lastValidCode) return "";
  if (lastValidCode.validationType === "procedure") return lastValidCode.validCode;
  
  const resultCode = checkTypeOfCode(lastValidCode.validCode);
  if (!codebookusaEnv && codingscreendata?.data?.meta?.is_DCID === true) {
    return `${resultCode?.charAt(0)}2${lastValidCode.validCode}`;
  }
  return `2${lastValidCode.validCode}`;
})();
  console.log(lastCode,'lastCode');
  
      setDiagnosisStates((prevStates) => {
        let updatedStates = {
          principal: [...prevStates["principal"]],
          additional: [...prevStates["additional"]],
          procedure: [...prevStates["procedure"]],
        };

        if (type === "principal") {
              const normalizePrincipalCode = (code) => {
      if (!code) return "";
      return code
        .replace(/^[A-Za-z]+/, "")   
        .replace(/^[12]/, "")        
        .replace(/[./]/g, "")         
        .toUpperCase();               
    };
    const principalEntry = newValidCodes.find(
      ({ validCode }) =>
        normalizePrincipalCode(validCode) ===
        normalizePrincipalCode(principalCode),
    );


          if (
            prevPrincipal?.code &&
            principalEntry &&
            prevPrincipal?.code?.replace(/^[12]/, "") !==
              principalEntry?.code?.replace(/^[12]/, "") &&
            !updatedStates["additional"].some(
              (item) =>
                item?.code?.replace(/^[12]/, "") ===
                prevPrincipal?.code?.replace(/^[12]/, ""),
            )
          ) {
            updatedStates["additional"] = [
              prevPrincipal,
              ...updatedStates["additional"],
            ];
          }
          const principalEntryCode = checkTypeOfCode(principalEntry?.validCode);

          if (principalEntry) {
            updatedStates["principal"] = [
              {
                ...principalEntry,
                code:
                  !codebookusaEnv &&
                  codingscreendata?.data?.meta?.is_DCID === true
                    ? `${principalEntryCode?.charAt(0)}2${principalEntry.validCode}`
                    : `2${principalEntry.validCode}`,
              },
            ];
          }
        }

        orderedValidCodes.forEach(
          ({ validCode, description, warning, validationType, acs, nca }) => {
            const normalizedCode = validCode.replace(/^[12]/, "");
            const alreadyExistsInAdditional = updatedStates["additional"].some(
              (item) => item?.code?.replace(/^[12]/, "") === normalizedCode,
            );
            const alreadyExistsInPrincipal = updatedStates["principal"].some(
              (item) => item?.code?.replace(/^[12]/, "") === normalizedCode,
            );

            if (!alreadyExistsInAdditional && !alreadyExistsInPrincipal) {
              const resultCode = checkTypeOfCode(validCode);

              const prefixedCode =
                validationType !== "procedure" && !codebookusaEnv
                  ? codingscreendata?.data?.meta?.is_DCID === true
                    ? `${resultCode?.charAt(0)}2${validCode}`
                    : `2${validCode}`
                  : validationType !== "procedure" && codebookusaEnv
                    ? `2${validCode}`
                    : validCode;
              insertCode(
                prefixedCode,
                description,
                validationType,
                warning,
                acs,
                nca
              );
              const newEntry = {
                code: prefixedCode,
                description,
                warning,
                acs,
                nca
              };

              if (validationType === "additional") {
                if (type === "principal") {
                  updatedStates["additional"].unshift(newEntry);
                } else {
                  updatedStates["additional"].push(newEntry);
                }
              }
               else if (validationType === "procedure") {
                updatedStates["procedure"].push(newEntry);
              }

            }
          },
        );
        setTimeout(() => {
          const triggerCode =
            newValidCodes[newValidCodes.length - 1]?.code?.replace(
              /^[12]/,
              "",
            ) || "";
            console.log(updatedStates,'updatedStates');
            
          triggerWarnings(updatedStates, lastCode,false,hasPrincipalHAC);
        }, 0);

        return updatedStates;
      });
      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...newValidCodes.map(({ validCode }) => validCode),
      ]);

      const lastInsertedCode =
        newValidCodes[newValidCodes.length - 1]?.validCode;
      const popupWarning = newValidCodes.find(
        ({ validCode, warning }) =>
          validCode === lastInsertedCode && warning.should_popup,
      );

      if (popupWarning) {
        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(popupWarning.warning.warning_description);
        setModalVisible(true);
      }

      setEnteredCode((prev) => ({ ...prev, [type]: "" }));
    } catch (error) {
      console.log(error);
    } finally {
      setIsAnimation(false);
      // setAuditedStatus(false);
      // const newEpisodeListFilterObj = sessionStorage.getItem("filters");
      // const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
      // setTimeout(() => {
      //   dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {

      //     const newEpisodeRecord = res.payload?.episode?.find(
      //       (episode) => episode?.hcp_line_id === Number(hcpLineId),
      //     );

      //     if (newEpisodeRecord) {
      //       dispatch(selectedEpisodeList(newEpisodeRecord));
      //     }
      //   });
      // }, 300);
    }
  };

  const handleDropUSA = async (event, type) => {
    // setStopDrop(true);
    event.preventDefault();
    setIsAnimation(true);
    setAuditedStatus(true);
    try {
      let draggedData;
      try {
        draggedData = JSON.parse(
          event.dataTransfer.getData("application/json"),
        );
      } catch (error) {
        toast.error("Invalid data format");
        return;
      }

      const { codes, tab } = draggedData;
      if (!codes || !Array.isArray(codes) || codes.length === 0) {
        toast.error("Invalid codes!");
        return;
      }
      const getExistingCodesByType = (type) => {
        switch (type) {
          case "principal":
          case "additional":
            //ICD uniqueness across both sections
            return [
              ...diagnosisStates["principal"],
              ...diagnosisStates["additional"],
            ];
          case "procedure":
            return diagnosisStates["procedure"];
          default:
            return [];
        }
      };

      const existingCodes = new Set(
        getExistingCodesByType(type)
          .map((item) => item?.code)
          .filter(Boolean),
      );

      const isICD =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        codebooksanprodEnv ||
        pallasaiTestCodebookEnv ||
        codebooksanhcEnv ||
        codebookfigiEnv
          ? tab.includes("ICD 10 AM")
          : codebookusaEnv
            ? tab.includes("ICD 10 CM")
            : false;
      const isACHI =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        codebooksanprodEnv ||
        pallasaiTestCodebookEnv ||
        codebooksanhcEnv ||
        codebookfigiEnv
          ? tab.includes("ACHI")
          : codebookusaEnv
            ? ["PCS Index", "PCS Tabular", "CPT Tabular"].some((v) =>
                tab.includes(v),
              )
            : false;

      // if (
      //   (type === "procedure" && isICD) ||
      //   ((type === "additional" || type === "principal") && isACHI)
      // ) {
      //   type =
      //     codebookdevEnv ||
      //     codebookinternalEnv ||
      //     codebookcoblhEnv ||
      //     codebooknmhsEnv ||
      //     codebooksanEnv ||
      //     pallasaiTestCodebookEnv ||
      //     codebooksanhcEnv ||
      //     codebookfigiEnv
      //       ? "ACHI"
      //       : codebookusaEnv
      //       ? "CPT"
      //       : "";
      //   toast.warning(
      //     `${isICD ? "ICD" : type} codes can't be inserted in ${
      //       codebookusaEnv && typeOfPatient !== "outPatient"
      //         ? isICD
      //           ? "ACHI"
      //           : "ICD"
      //         : isICD
      //         ? "ACHI"
      //         : "ICD"
      //     } section`
      //   );
      //   return;
      // }
      // 🚫 Invalid section drop — SHOW TOAST ALWAYS


      if (type === "procedure" && isICD) {
        toast.warning("ICD codes can't be inserted in Procedure section");
        return;
      }

      if ((type === "principal" || type === "additional") && isACHI) {
        if (tab.includes("PCS Index") || tab.includes("PCS Tabular")) {
          toast.warning("PCS codes can't be inserted in ICD section");
        } else {
          toast.warning("CPT codes can't be inserted in ICD section");
        }
        return;
      }

      let extractedCodesArray = [];
      codes.forEach((code) => {
        code = code.trim();
        if (!code) return;

        if (/^\([^()]+\)$/.test(code)) {
          extractedCodesArray.push(code.slice(1, -1).trim());
          return;
        }

        const match = code.match(/^\(([^)]+)\)(.+)$/);
        if (match) {
          extractedCodesArray.push(match[2].trim());
          extractedCodesArray.push(match[1].trim());
        } else {
          extractedCodesArray.push(code);
        }
      });
      let principalCode = extractedCodesArray[0];
      if (type === "principal" && isCodeRestricted(principalCode)) {
        toast.warning(
          `Code is restricted and cannot be added to the Principal section.`,
        );
        return;
      }
      let additionalCodes = extractedCodesArray.slice(1);
      let prevPrincipal = diagnosisStates["principal"][0];

      const removeLeadingDigits = (codeSet) => {
        return new Set(
          [...codeSet]
            ?.filter((c) => typeof c === "string" && c?.length > 0)
            ?.map((code) => {
              if (/^[A-Za-z]/.test(code)) {
                return code;
              }
              return code?.replace(/^\d+/, "");
            }),
        );
      };

      const cleanUPCodes = removeLeadingDigits(existingCodes);

      let uniqueNewCodes = extractedCodesArray?.filter((code) => {
        if (typeof code !== "string" || code?.length === 0) return false;

        const isDuplicate = cleanUPCodes?.has(code);

        return !isDuplicate;
      });


      // if (uniqueNewCodes?.length === 0) {
      //   toast.warning("Codes already exist!");
      //   return;
      // }

      let finalValidCodes = [];
      let newPrincipalWarnings = [];
      let newAdditionalWarnings = [];
      let popupWarnings = [];

      const validationResults = await Promise.all(
        uniqueNewCodes.map(async (extractedCode) => {
          const validationType =
            extractedCode.replace(/^[12]/, "") ===
              principalCode.replace(/^[12]/, "") && type === "principal"
              ? "principal"
              : type === "procedure"
                ? "procedure"
                : "additional";
          const {
            valid,
            description,
            isWarning,
            warningDescription,
            isPopup,
            acs,
          } = await validateCodeAPI(extractedCode, validationType);

          if (!valid) return null;

          const warning = {
            is_warning: isWarning,
            should_popup: isPopup,
            warning_description: warningDescription,
          };

          if (isWarning && warningDescription) {
            if (validationType === "principal") {
              newPrincipalWarnings.push(warningDescription);
            } else {
              newAdditionalWarnings.push(warningDescription);
            }
          }

          if (isPopup) {
            popupWarnings.push({
              code: extractedCode,
              message: warningDescription,
            });
          }

          return {
            code: extractedCode,
            description,
            warning,
            validationType,
            acs,
          };
        }),
      );

      finalValidCodes = validationResults.filter(Boolean);
      // if (finalValidCodes.length === 0) {
      //   toast.warning("Code already exists");
      //   return;
      // }
      const removeFirstChar = (codeSet) => {
        return new Set(
          Array.from(codeSet)
            .filter((code) => code && code.length > 1)
            .map((code) => code.slice(1)),
        );
      };
      const cleanUPCodesWithoutFirstChar =
        type === "procedure" ? existingCodes : removeFirstChar(cleanUPCodes);
      const nonDuplicateValidCodes = finalValidCodes.filter(({ code }) => {
        const normalizedCode = code;

        if (cleanUPCodesWithoutFirstChar.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });

      
      //Early duplicate check for procedure section
      if (type === "procedure") {
        const normalizedExisting = new Set(
          diagnosisStates["procedure"]
            .map((item) => item?.code)
            .filter(Boolean),
        );
        const duplicateCodes = extractedCodesArray.filter((code) =>
          normalizedExisting.has(code),
        );

        if (duplicateCodes.length > 0) {
          toast.warning(`Code ${duplicateCodes[0]} already exists!`);
          return;
        }
      }
      if (nonDuplicateValidCodes.length === 0) {
        // toast.warning("Codes already exist!");
        return;
      }

      await Promise.all(
        nonDuplicateValidCodes.map(
          ({ code, description, warning, validationType }) => {
            if (type !== "principal") {
              const resultCode = checkTypeOfCode(code);

              return insertCode(
                validationType !== "procedure" && !codebookusaEnv
                  ? `${resultCode?.charAt(0)}Y${code.replace(/^[12]/, "")}`
                  : validationType !== "procedure" && codebookusaEnv
                    ? `Y${code.replace(/^[12]/, "")}`
                    : code,
                description,
                validationType,
                warning,
                acs,
              );
            } else {
              return Promise.resolve(); // Avoid unhandled promises
            }
          },
        ),
      );

      setIconDispaly(true);
      saveToHistory();

      setDiagnosisStates((prevStates) => {
        let updatedStates = { ...prevStates };

        if (type === "principal") {
          const principalEntry = nonDuplicateValidCodes.find(
            ({ code }) =>
              code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, ""),
          );

          if (
            prevPrincipal?.code &&
            !prevStates["additional"].some(
              (item) =>
                item?.code?.replace(/^[12]/, "") ===
                prevPrincipal?.code?.replace(/^[12]/, ""),
            )
          ) {
            updatedStates["additional"] = [
              prevPrincipal,
              ...prevStates["additional"],
            ];

            insertCode(
              // prevPrincipal?.code?.replace(/^[12]/, ""),
              prevPrincipal?.code,
              prevPrincipal?.description,
              "additional",
              prevPrincipal.warning,
            );
          }

          if (principalEntry) {
            const prevPrincipalCode = checkTypeOfCode(principalEntry.code);

            updatedStates["principal"] = [
              {
                ...principalEntry,
                code: !codebookusaEnv
                  ? `${prevPrincipalCode?.charAt(
                      0,
                    )}Y${principalEntry.code.replace(/^[12]/, "")}`
                  : `Y${principalEntry.code.replace(/^[12]/, "")}`,
                acs: principalEntry.acs,
              },
            ];
          }
        }

        const additionalEntries = nonDuplicateValidCodes.filter(({ code }) => {
          const normalized = code.replace(/^[12]/, "");
          return (
            additionalCodes.includes(normalized) &&
            normalized !== principalCode.replace(/^[12]/, "") &&
            !prevStates["additional"].some(
              (item) => item.code.replace(/^[12]/, "") === normalized,
            )
          );
        });

        const additionalCodesNormalized = additionalCodes.map((code) =>
          code.replace(/^[12]/, ""),
        );

        let reorderedAdditional = [];

        if (type === "principal") {
          const allTopCodes = [...additionalCodesNormalized];

          if (
            prevPrincipal &&
            !allTopCodes.includes(prevPrincipal?.code?.replace(/^[12]/, ""))
          ) {
            allTopCodes.push(prevPrincipal?.code?.replace(/^[12]/, ""));
          }

          reorderedAdditional = [
            ...allTopCodes
              .map((normalizedCode) => {
                const found = nonDuplicateValidCodes.find(
                  ({ code }) => code.replace(/^[12]/, "") === normalizedCode,
                );
                if (found) {
                  const resultCode = checkTypeOfCode(found.code);
                  return {
                    ...found,
                    code: !codebookusaEnv
                      ? `${resultCode?.charAt(0)}Y${found.code.replace(
                          /^[12]/,
                          "",
                        )}`
                      : `Y${found.code.replace(/^[12]/, "")}`,
                    acs: found.acs,
                  };
                }

                const existing = prevStates["additional"].find(
                  (item) => item.code.replace(/^[12]/, "") === normalizedCode,
                );
                if (existing) return existing;

                if (
                  prevPrincipal?.code &&
                  prevPrincipal?.code?.replace(/^[12]/, "") === normalizedCode
                ) {
                  insertCode(
                    // prevPrincipal?.code?.replace(/^[12]/, ""),
                    prevPrincipal?.code,
                    prevPrincipal?.description,
                    "additional",
                    prevPrincipal?.warning,
                  );
                  return {
                    ...prevPrincipal,
                    // code: prevPrincipal?.code?.replace(/^[12]/, ""),
                    code: prevPrincipal?.code,
                    acs: prevPrincipal?.acs,
                  };
                }

                return null;
              })
              .filter(Boolean),

            ...prevStates["additional"].filter(
              (item) => !allTopCodes.includes(item?.code?.replace(/^[12]/, "")),
            ),
          ];
        } else if (type === "additional") {
          const newCodesToAppend = additionalCodesNormalized
            .filter(
              (normalizedCode) =>
                !prevStates["additional"].some(
                  (item) => item?.code?.replace(/^[12]/, "") === normalizedCode,
                ),
            )
            .map((normalizedCode) => {
              const found = nonDuplicateValidCodes.find(
                ({ code }) => code?.replace(/^[12]/, "") === normalizedCode,
              );
              if (found) {
                return {
                  ...found,
                  code: found?.code?.replace(/^[12]/, ""),
                  acs: found.acs,
                };
              }
              return null;
            })
            .filter(Boolean);

          reorderedAdditional = [
            ...prevStates["additional"],
            ...newCodesToAppend,
          ];
        }

        // Only update "additional" section if it's relevant to the drop type
        if (type === "principal" || type === "additional") {
          updatedStates["additional"] = reorderedAdditional;
        }


        return updatedStates;
      });

      setWarningMessage((prevWarnings) => {
        let updatedWarnings = [...prevWarnings];

        const filteredPrincipalWarnings = newPrincipalWarnings.filter(
          (warning) =>
            !popupWarnings.some((popup) => popup.message === warning),
        );

        const filteredAdditionalWarnings = newAdditionalWarnings.filter(
          (warning) =>
            !popupWarnings.some((popup) => popup.message === warning),
        );

        // When replacing principal code, remove ALL COF warnings
        // (User can set COF later via dropdown if needed)
        if (type === "principal") {
          // Remove all COF warnings when principal code is replaced
          updatedWarnings = updatedWarnings.filter(
            (warning) => !warning.includes("has COF"),
          );
        }

        if (filteredPrincipalWarnings.length > 0) {
          updatedWarnings = [
            filteredPrincipalWarnings[0],
            ...updatedWarnings.filter(
              (w) => w !== filteredPrincipalWarnings[0],
            ),
          ];
        }

        filteredAdditionalWarnings.forEach((warning) => {
          if (!updatedWarnings.includes(warning)) {
            updatedWarnings.push(warning);
          }
        });

        return updatedWarnings;
      });

      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...nonDuplicateValidCodes.map(({ code }) => code),
      ]);
      const lastInsertedCode =
        nonDuplicateValidCodes[nonDuplicateValidCodes.length - 1]?.code;
      const popupWarning = popupWarnings.find(
        (w) => w.code === lastInsertedCode,
      );

      if (popupWarning) {
        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(popupWarning.message);
        setModalVisible(true);
      }
    } catch (error) {
      console.error("Error handling drop:", error);
    } finally {
      setIsAnimation(false);
      setAuditedStatus(false);
      // const newEpisodeListFilterObj = sessionStorage.getItem("filters");
      // const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
      // dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {

      //   const newEpisodeRecord = res.payload?.episode?.find(
      //     (episode) => episode?.hcp_line_id === Number(hcpLineId),
      //   );

      //   if (newEpisodeRecord) {
      //     dispatch(selectedEpisodeList(newEpisodeRecord));
      //   }
      // });
    }
  };

  const handleDrop = async (event, type) => {
    // setStopDrop(true);
    event.preventDefault();
    setIsAnimation(true);
    setAuditedStatus(true);
    try {
      let draggedData;
      try {
        draggedData = JSON.parse(
          event.dataTransfer.getData("application/json"),
        );
      } catch (error) {
        toast.error("Invalid data format");
        return;
      }

      const { codes, tab } = draggedData;
      // console.log(draggedData, 'draggeddata')

      if (!codes || !Array.isArray(codes) || codes.length === 0) {
        toast.error("Invalid codes!");
        return;
      }
      const getExistingCodesByType = (type) => {
        switch (type) {
          case "principal":
          case "additional":
            return [
              ...diagnosisStates["principal"],
              ...diagnosisStates["additional"],
            ];
          case "procedure":
            return diagnosisStates["procedure"];
          default:
            return [];
        }
      };

      const existingCodes = new Set(
        getExistingCodesByType(type)
          .map((item) => item?.code)
          .filter(Boolean),
      );

      const isICD =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        pallasaiTestCodebookEnv ||
        codebooksanhcEnv ||
        codebooksanprodEnv ||
        codebookfigiEnv
          ? tab.includes("ICD 10 AM")
          : codebookusaEnv
            ? tab.includes("ICD 10 CM")
            : false;
      const isACHI =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        codebooksanprodEnv ||
        pallasaiTestCodebookEnv ||
        codebooksanhcEnv ||
        codebookfigiEnv
          ? tab.includes("ACHI")
          : codebookusaEnv
            ? tab.includes("CPT")
            : false;

      if (
        (type === "procedure" && isICD) ||
        ((type === "additional" || type === "principal") && isACHI)
      ) {
        type =
          codebookdevEnv ||
          codebookinternalEnv ||
          codebookcoblhEnv ||
          codebooknmhsEnv ||
          codebooksanEnv ||
          pallasaiTestCodebookEnv ||
          codebooksanhcEnv ||
          codebooksanprodEnv ||
          codebookfigiEnv
            ? "ACHI"
            : codebookusaEnv
              ? "CPT"
              : "";
        toast.warning(
          `${isICD ? "ICD" : type} codes can't be inserted in ${
            codebookusaEnv && typeOfPatient !== "outPatient"
              ? isICD
                ? "ACHI"
                : "ICD"
              : isICD
                ? "ACHI"
                : "ICD"
          } section`,
        );
        return;
      }
      let prevPrincipal = diagnosisStates["principal"][0];
      let extractedCodesArray = [];
      if (type === "principal" && diagnosisStates["principal"][0]?.code) {
        const existingPrincipalCode = diagnosisStates[
          "principal"
        ][0].code.replace(/^[12]/, "");

        extractedCodesArray = extractedCodesArray.filter(
          (code) => code.replace(/^[12]/, "") !== existingPrincipalCode,
        );
      }


      // Find the code with parentheses
      let parenIndex = codes.findIndex((code) =>
        code.trim().match(/^\([^()]+\)$/),
      );
      let parenCode = null;
      let otherCodes = [];

      if (parenIndex !== -1) {
        // Extract the code inside parentheses
        parenCode = codes[parenIndex].trim().slice(1, -1).trim();

        // Get all other codes (excluding the parentheses code)
        otherCodes = codes
          .filter((_, index) => index !== parenIndex)
          .map((code) => code.trim());

        if (otherCodes.length > 0) {
          extractedCodesArray.push(otherCodes[0]);
        }
        extractedCodesArray.push(parenCode);

        if (otherCodes.length > 1) {
          extractedCodesArray.push(...otherCodes.slice(1));
        }
      } else {
        extractedCodesArray = codes.map((code) => code.trim());
      }

      let principalCode = extractedCodesArray[0];
      if (type === "principal" && isCodeRestricted(principalCode)) {
        toast.warning(
          `Code is restricted and cannot be added to the Principal section.`,
        );
        return;
      }
      let additionalCodes = extractedCodesArray.slice(1);

      const removeLeadingDigits = (codeSet,type) => {
        // console.log(codeSet,'codesetnew');
        
        return new Set(
          [...codeSet]
            ?.filter((c) => typeof c === "string" && c?.length > 0)
            ?.map((code) => {
              if(type === 'procedure'){
                return code;
              }
              if (/^[A-Za-z]/.test(code)) {
                return code;
              }
              return code?.replace(/^\d+/, "");
            }),
        );
      };

      const cleanUPCodes = removeLeadingDigits(existingCodes,type);
      // console.log(cleanUPCodes,extractedCodesArray,existingCodes,'kjshdksjehfs');
      

      let uniqueNewCodes = extractedCodesArray?.filter((code) => {
        if (typeof code !== "string" || code?.length === 0) return false;

        const isDuplicate = cleanUPCodes?.has(code);

        return !isDuplicate;
      });


      if (uniqueNewCodes?.length === 0) {
        toast.warning("Codes already exist!");
        return;
      }

      let finalValidCodes = [];
      let newPrincipalWarnings = [];
      let newAdditionalWarnings = [];
      let popupWarnings = [];

      const validationResults = await Promise.all(
        uniqueNewCodes.map(async (extractedCode) => {
          const validationType =
            extractedCode.replace(/^[12]/, "") ===
              principalCode.replace(/^[12]/, "") && type === "principal"
              ? "principal"
              : type === "procedure"
                ? "procedure"
                : "additional";
          const {
            valid,
            description,
            isWarning,
            warningDescription,
            isPopup,
            acs,
            nca
          } = await validateCodeAPI(extractedCode, validationType);

          if (!valid) return null;

          const warning = {
            is_warning: isWarning,
            should_popup: isPopup,
            warning_description: warningDescription,
          };

          if (isWarning && warningDescription) {
            if (validationType === "principal") {
              newPrincipalWarnings.push(warningDescription);
            } else {
              newAdditionalWarnings.push(warningDescription);
            }
          }

          if (isPopup) {
            popupWarnings.push({
              code: extractedCode,
              message: warningDescription,
            });
          }

          return {
            code: extractedCode,
            description,
            warning,
            validationType,
            acs,
            nca
          };
        }),
      );

      finalValidCodes = validationResults.filter(Boolean);
      if (finalValidCodes.length === 0) {
        toast.warning("ACHI codes can't be inserted in ICD section");
        return;
      }

      const nonDuplicateValidCodes = finalValidCodes.filter(({ code }) => {
        const normalizedCode = code.replace(/^[12]/, "");
        if (cleanUPCodes.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });

      if (nonDuplicateValidCodes.length === 0) {
        toast.warning("Codes already exist!");
        return;
      }
      await Promise.all(
        nonDuplicateValidCodes.map(
          ({ code, description, warning, validationType, acs, nca }) => {
            if (type !== "principal") {
              const resultCode = checkTypeOfCode(code);
              return insertCode(
                validationType !== "procedure" && !codebookusaEnv
                  ? codingscreendata?.data?.meta?.is_DCID === true
                    ? `${resultCode?.charAt(0)}2${code.replace(/^[12]/, "")}`
                    : `2${code.replace(/^[12]/, "")}`
                  : validationType !== "procedure" && codebookusaEnv
                    ? `2${code.replace(/^[12]/, "")}`
                    : code,
                description,
                validationType,
                warning,
                acs,
                nca
              );
            } else {
              return Promise.resolve(); // Avoid unhandled promises
            }
          },
        ),
      );
        console.log('pppppp1');
      
      setIconDispaly(true);
      saveToHistory();
      let updatedStateRef = null;
      setDiagnosisStates((prevStates) => {
        let updatedStates = { ...prevStates };

        if (type === "principal") {
          const principalEntry = nonDuplicateValidCodes.find(
            ({ code }) =>
              code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, ""),
          );

          if (
            prevPrincipal?.code &&
            !prevStates["additional"].some(
              (item) =>
                item?.code?.replace(/^[12]/, "") ===
                prevPrincipal?.code?.replace(/^[12]/, ""),
            )
          ) {
            updatedStates["additional"] = [
              prevPrincipal,
              ...prevStates["additional"],
            ];

            insertCode(
              // prevPrincipal?.code?.replace(/^[12]/, ""),
              prevPrincipal?.code,
              prevPrincipal?.description,
              "additional",
              prevPrincipal.warning,
            );
          }

          if (principalEntry) {
            const prevPrincipalCode = checkTypeOfCode(principalEntry.code);

            updatedStates["principal"] = [
              {
                ...principalEntry,
                code:
                  !codebookusaEnv &&
                  codingscreendata?.data?.meta?.is_DCID === true
                    ? `${prevPrincipalCode?.charAt(0)}2${principalEntry.code.replace(/^[12]/, "")}`
                    : `2${principalEntry.code.replace(/^[12]/, "")}`,
                acs: principalEntry.acs,
                nca: principalEntry.nca,
              },
            ];
          }
        }

        const additionalEntries = nonDuplicateValidCodes.filter(({ code }) => {
          const normalized = code.replace(/^[12]/, "");
          return (
            additionalCodes.includes(normalized) &&
            normalized !== principalCode.replace(/^[12]/, "") &&
            !prevStates["additional"].some(
              (item) => item.code.replace(/^[12]/, "") === normalized,
            )
          );
        });

        const additionalCodesNormalized = additionalCodes.map((code) => code);

        let reorderedAdditional = [];

        if (type === "principal") {
          const allTopCodes = [...additionalCodesNormalized];

          if (
            prevPrincipal &&
            !allTopCodes.includes(prevPrincipal?.code?.replace(/^[12]/, ""))
          ) {
            allTopCodes.push(prevPrincipal?.code?.replace(/^[12]/, ""));
          }

          reorderedAdditional = [
            ...allTopCodes
              .map((normalizedCode) => {
                const found = nonDuplicateValidCodes.find(
                  ({ code }) => code.replace(/^[12]/, "") === normalizedCode,
                );
                if (found) {
                  const resultCode = checkTypeOfCode(found.code);
                  return {
                    ...found,
                    code:
                      !codebookusaEnv &&
                      codingscreendata?.data?.meta?.is_DCID === true
                        ? `${resultCode?.charAt(0)}2${found.code.replace(/^[12]/, "")}`
                        : `2${found.code.replace(/^[12]/, "")}`,
                    acs: found.acs,
                    nca: found.nca,
                  };
                }

                const existing = prevStates["additional"].find(
                  (item) => item.code.replace(/^[12]/, "") === normalizedCode,
                );
                if (existing) return existing;

                if (
                  prevPrincipal?.code &&
                  prevPrincipal?.code?.replace(/^[12]/, "") === normalizedCode
                ) {
                  insertCode(
                    // prevPrincipal?.code?.replace(/^[12]/, ""),
                    prevPrincipal?.code,
                    prevPrincipal?.description,
                    "additional",
                    prevPrincipal?.warning,
                  );
                  return {
                    ...prevPrincipal,
                    // code: prevPrincipal?.code?.replace(/^[12]/, ""),
                    code: prevPrincipal?.code,
                    acs: prevPrincipal?.acs,
                    nca: prevPrincipal?.nca,
                  };
                }

                return null;
              })
              .filter(Boolean),

            ...prevStates["additional"].filter(
              (item) => !allTopCodes.includes(item?.code?.replace(/^[12]/, "")),
            ),
          ];
        } else if (type === "additional") {
          const newCodesToAppend = additionalCodesNormalized
            .filter(
              (normalizedCode) =>
                !prevStates["additional"].some(
                  (item) => item?.code?.replace(/^[12]/, "") === normalizedCode,
                ),
            )
            .map((normalizedCode) => {
              const found = nonDuplicateValidCodes.find(
                ({ code }) => code?.replace(/^[12]/, "") === normalizedCode,
              );
              if (found) {
                return {
                  ...found,
                  code: found?.code?.replace(/^[12]/, ""),
                  acs: found.acs,
                  nca: found.nca,
                };
              }
              return null;
            })
            .filter(Boolean);

          reorderedAdditional = [
            ...prevStates["additional"],
            // ...newCodesToAppend,
          ];
        }

        // Only update "additional" section if it's relevant to the drop type
        if (type === "principal" || type === "additional") {
          updatedStates["additional"] = reorderedAdditional;
        }

        updatedStateRef = updatedStates;
        return updatedStates;
      });
      setTimeout(() => {
        if (!updatedStateRef) return;   
        const lastValid =
          nonDuplicateValidCodes[nonDuplicateValidCodes.length - 1];
        const triggerCode = (() => {
          if (!lastValid) return "";
          if (lastValid.validationType === "procedure") return lastValid.code;

          const resultCode = checkTypeOfCode(lastValid.code);
          if (
            !codebookusaEnv &&
            codingscreendata?.data?.meta?.is_DCID === true
          ) {
            return `${resultCode?.charAt(0)}2${lastValid.code.replace(/^[12]/, "")}`;
          }
          return `2${lastValid.code.replace(/^[12]/, "")}`;
        })();
        triggerWarnings(updatedStateRef, triggerCode,false,hasPrincipalHAC);
      }, 0);

      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...nonDuplicateValidCodes.map(({ code }) => code),
      ]);
      const lastInsertedCode =
        nonDuplicateValidCodes[nonDuplicateValidCodes.length - 1]?.code;
      const popupWarning = popupWarnings.find(
        (w) => w.code === lastInsertedCode,
      );

      if (popupWarning) {
        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(popupWarning.message);
        setModalVisible(true);
      }
    } catch (error) {
      console.error("Error handling drop:", error);
    } finally {
      setIsAnimation(false);
      setAuditedStatus(false);
      // const newEpisodeListFilterObj = sessionStorage.getItem("filters");
      // const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
      // dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {

      //   const newEpisodeRecord = res.payload?.episode?.find(
      //     (episode) => episode?.hcp_line_id === Number(hcpLineId),
      //   );

      //   if (newEpisodeRecord) {
      //     dispatch(selectedEpisodeList(newEpisodeRecord));
      //   }
      // });
    }
  };
  // const handleCodeAssistAdding = async (draggedData) => {
  //   setAuditedStatus(true);
  //   setIsAnimation(true);

  //   try {
  //     const parsedData = JSON.parse(draggedData);

  //     // Check if draggedData is in new format
  //     const isNewFormat =
  //       parsedData.hasOwnProperty("Principal Diagnosis") ||
  //       parsedData.hasOwnProperty("Additional Diagnoses") ||
  //       parsedData.hasOwnProperty("Procedure Diagnosis");

  //     if (isNewFormat) {
  //       const sectionMap = {
  //         "Principal Diagnosis": "principal",
  //         "Additional Diagnoses": "additional",
  //         "Procedure Codes": "procedure",
  //       };

  //       for (const [key, type] of Object.entries(sectionMap)) {
  //         const entries = parsedData[key] || [];

  //         for (const entry of entries) {
  //           const codesToInsert = entry.codes || [];

  //           const fakeDraggedData = JSON.stringify({
  //             tab:
  //               type === "principal"
  //                 ? "Principal diagnosis"
  //                 : type === "additional"
  //                 ? "ICD 10 AM Index"
  //                 : "ACHI Tab", // Replace with actual tab name for procedure
  //             codes: codesToInsert,
  //           });

  //           await handleCodeAssistAdding(fakeDraggedData);
  //         }
  //       }

  //       return;
  //     }

  //     let type;

  //     if (parsedData.tab === "ICD 10 AM Index") {
  //       type = "additional";
  //     } else if (parsedData.tab === "Principal diagnosis") {
  //       type = "principal";
  //     } else {
  //       type = "procedure";
  //     }


  //     const { codes, tab } = parsedData;
  //     if (!codes || !Array.isArray(codes) || codes.length === 0) {
  //       toast.error("Invalid codes!");
  //       return;
  //     }

  //     const existingCodes = new Set([
  //       ...diagnosisStates["principal"].map((item) =>
  //         item?.code?.replace(/^[12]/, "")
  //       ),
  //       ...diagnosisStates["additional"].map((item) =>
  //         item?.code?.replace(/^[12]/, "")
  //       ),
  //       ...diagnosisStates["procedure"].map((item) =>
  //         item?.code?.replace(/^[12]/, "")
  //       ),
  //     ]);

  //     const isICD = tab.includes("ICD 10 AM");
  //     const isACHI = tab.includes("ACHI");
  //     if (
  //       (type === "procedure" && isICD) ||
  //       ((type === "additional" || type === "principal") && isACHI)
  //     ) {
  //       toast.warning(
  //         `${
  //           isICD ? "ICD" : "ACHI"
  //         } codes can't be inserted in ${type.toUpperCase()} section`
  //       );
  //       return;
  //     }

  //     let extractedCodesArray = [];
  //     codes.forEach((code) => {
  //       code = code.trim();
  //       if (!code) return;

  //       const match = code.match(/^\(([^)]+)\)(.+)$/);
  //       if (match) {
  //         extractedCodesArray.push(match[2].trim());
  //         extractedCodesArray.push(match[1].trim());
  //       } else {
  //         extractedCodesArray.push(code);
  //       }
  //     });

  //     let principalCode = extractedCodesArray[0];
  //     let additionalCodes = extractedCodesArray.slice(1);
  //     let prevPrincipal = diagnosisStates["principal"][0];
  //     let duplicateCodes = extractedCodesArray.filter((code) =>
  //       existingCodes.has(code.replace(/^[12]/, ""))
  //     );

  //     let uniqueNewCodes = extractedCodesArray.filter(
  //       (code) => !existingCodes.has(code.replace(/^[12]/, ""))
  //     );

  //     if (duplicateCodes.length > 0) {
  //       toast.warning(
  //         `Duplicate code${
  //           duplicateCodes.length > 1 ? "s" : ""
  //         } found: ${duplicateCodes
  //           .map((code) => code.replace(/^[12]/, ""))
  //           .join(", ")}`
  //       );
  //     }

  //     if (uniqueNewCodes.length === 0) {
  //       return; // No new codes to insert
  //     }

  //     let finalValidCodes = [];
  //     let newPrincipalWarnings = [];
  //     let newAdditionalWarnings = [];
  //     let popupWarnings = [];

  //     const validationResults = await Promise.all(
  //       uniqueNewCodes.map(async (extractedCode) => {
  //         const validationType =
  //           extractedCode.replace(/^[12]/, "") ===
  //             principalCode.replace(/^[12]/, "") && type === "principal"
  //             ? "principal"
  //             : type === "procedure"
  //             ? "procedure"
  //             : "additional";

  //         const { valid, description, isWarning, warningDescription, isPopup } =
  //           await validateCodeAPI(extractedCode, validationType);

  //         if (!valid) return null;

  //         const warning = {
  //           is_warning: isWarning,
  //           should_popup: isPopup,
  //           warning_description: warningDescription,
  //         };

  //         if (isWarning && warningDescription) {
  //           if (validationType === "principal") {
  //             newPrincipalWarnings.push(warningDescription);
  //           } else {
  //             newAdditionalWarnings.push(warningDescription);
  //           }
  //         }

  //         if (isPopup) {
  //           popupWarnings.push({
  //             code: extractedCode,
  //             message: warningDescription,
  //           });
  //         }

  //         return { code: extractedCode, description, warning, validationType };
  //       })
  //     );

  //     finalValidCodes = validationResults.filter(Boolean);
  //     if (finalValidCodes.length === 0) {
  //       toast.warning("No valid new codes to insert!");
  //       return;
  //     }

  //     const nonDuplicateValidCodes = finalValidCodes.filter(({ code }) => {
  //       const normalizedCode = code.replace(/^[12]/, "");
  //       if (existingCodes.has(normalizedCode)) {
  //         toast.warning(`Code ${normalizedCode} already exists!`);
  //         return false;
  //       }
  //       return true;
  //     });

  //     if (nonDuplicateValidCodes.length === 0) {
  //       toast.warning("Codes already exist!");
  //       return;
  //     }

  //     await Promise.all(
  //       nonDuplicateValidCodes.map(
  //         ({ code, description, warning, validationType }) =>
  //           insertCode(
  //             validationType !== "procedure"
  //               ? `2${code.replace(/^[12]/, "")}`
  //               : code,
  //             description,
  //             validationType,
  //             warning
  //           )
  //       )
  //     );
  //     setIconDispaly(true);
  //     saveToHistory();
  //     setDiagnosisStates((prevStates) => {
  //       let updatedStates = { ...prevStates };

  //       if (type === "principal") {
  //         const prevPrincipal = prevStates["principal"][0];
  //         const existingAdditional = prevStates["additional"];

  //         // Find the new principal code entry from nonDuplicateValidCodes
  //         const principalEntry = nonDuplicateValidCodes.find(
  //           ({ code }) =>
  //             code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, "")
  //         );

  //         // Codes inside parentheses from dragged data - must come first in additional
  //         const associatedAdditionalCodes = extractedCodesArray.slice(1); // skip first principal

  //         // Build array of additional codes to prepend, filtering duplicates
  //         let additionalToPrepend = [];

  //         // Insert any missing associated additional codes (in order)
  //         associatedAdditionalCodes.forEach((code) => {
  //           // Check if already exists in additional
  //           const normalizedCode = code.replace(/^[12]/, "");
  //           const alreadyInAdditional = existingAdditional.some(
  //             (item) => item.code.replace(/^[12]/, "") === normalizedCode
  //           );

  //           // Also check in nonDuplicateValidCodes for description etc
  //           const foundEntry = nonDuplicateValidCodes.find(
  //             (item) => item.code.replace(/^[12]/, "") === normalizedCode
  //           );

  //           if (!alreadyInAdditional && foundEntry) {
  //             additionalToPrepend.push({
  //               ...foundEntry,
  //               code: `2${foundEntry.code.replace(/^[12]/, "")}`, // normalize code prefix
  //             });
  //           }
  //         });

  //         // Move previous principal to additional if not already there
  //         if (
  //           prevPrincipal &&
  //           !existingAdditional.some(
  //             (item) =>
  //               item.code.replace(/^[12]/, "") ===
  //               prevPrincipal.code.replace(/^[12]/, "")
  //           )
  //         ) {
  //           additionalToPrepend.push({
  //             ...prevPrincipal,
  //             code: `2${prevPrincipal.code.replace(/^[12]/, "")}`,
  //           });

  //           // Insert code for previous principal as additional
  //           insertCode(
  //             `2${prevPrincipal.code.replace(/^[12]/, "")}`,
  //             prevPrincipal.description,
  //             "additional",
  //             prevPrincipal.warning
  //           );
  //         }

  //         // Filter out all prepended additional codes from existing additional to avoid duplicates
  //         const filteredAdditional = existingAdditional.filter(
  //           (item) =>
  //             !additionalToPrepend.some(
  //               (prepended) =>
  //                 prepended.code.replace(/^[12]/, "") ===
  //                 item.code.replace(/^[12]/, "")
  //             )
  //         );

  //         // Set new principal code
  //         if (principalEntry) {
  //           updatedStates["principal"] = [
  //             {
  //               ...principalEntry,
  //               code: `2${principalEntry.code.replace(/^[12]/, "")}`,
  //             },
  //           ];
  //         }

  //         // Prepend additionalToPrepend and then rest of existing additional codes
  //         updatedStates["additional"] = [
  //           ...additionalToPrepend,
  //           ...filteredAdditional,
  //         ];
  //       }

  //       return updatedStates;
  //     });

  //     setWarningMessage((prevWarnings) => {
  //       let updatedWarnings = [...prevWarnings];

  //       const filteredPrincipalWarnings = newPrincipalWarnings.filter(
  //         (warning) => !popupWarnings.some((popup) => popup.message === warning)
  //       );

  //       const filteredAdditionalWarnings = newAdditionalWarnings.filter(
  //         (warning) => !popupWarnings.some((popup) => popup.message === warning)
  //       );

  //       if (filteredPrincipalWarnings.length > 0) {
  //         updatedWarnings = [
  //           filteredPrincipalWarnings[0],
  //           ...updatedWarnings.filter(
  //             (w) => w !== filteredPrincipalWarnings[0]
  //           ),
  //         ];
  //       }

  //       filteredAdditionalWarnings.forEach((warning) => {
  //         if (!updatedWarnings.includes(warning)) {
  //           updatedWarnings.push(warning);
  //         }
  //       });

  //       return updatedWarnings;
  //     });

  //     setNewlyInsertedCodes((prev) => [
  //       ...prev,
  //       ...nonDuplicateValidCodes.map(({ code }) => code),
  //     ]);
  //     const lastInsertedCode =
  //       nonDuplicateValidCodes[nonDuplicateValidCodes.length - 1]?.code;
  //     const popupWarning = popupWarnings.find(
  //       (w) => w.code === lastInsertedCode
  //     );
  //     if (popupWarning) {
  //       setPendingCode(lastInsertedCode);
  //       setPendingType(type);
  //       setModalMessage(popupWarning.message);
  //       setModalVisible(true);
  //     }
  //   } catch (error) {
  //     console.error("Error handling drop:", error);
  //   } finally {
  //     setIsAnimation(false);
  //     setAuditedStatus(false);
  //     fetchData1();
  //     const newEpisodeListFilterObj = sessionStorage.getItem("filters");
  //     const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
  //     dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {

  //       const newEpisodeRecord = res.payload?.episode?.find(
  //         (episode) => episode?.hcp_line_id === Number(hcpLineId)
  //       );

  //       if (newEpisodeRecord) {
  //         dispatch(selectedEpisodeList(newEpisodeRecord));
  //       }
  //     });
  //   }
  // };

  const handleAcceptCodes = (code) => {
    // toast.success("Code is accepted");
    saveToHistory(); // Important!
    setAcceptedCodes((prev) => ({
      ...prev,
      [code]: true,
    }));
  };

  const normalizeCode = (code) => code?.replace(/^[12]/, ""); // Remove leading 1 or 2

  //  const handleCofSelect = (type, index, value, codeValue) => {
  //   const code = ["1", "2"].includes(codeValue[1]) ? codeValue?.slice(2) : codeValue?.slice(1)
  //     const normalizedCode = normalizeCode(code);
  //     const correctedType = type === "additional" ? "additional_diagnoses" : type;

  //     // Update selected COF value
  //     setSelectedCofValues((prev) => {
  //       const updatedArray = [...(prev[correctedType] || [])];
  //       const itemIndex = updatedArray.findIndex(
  //         (item) => normalizeCode(["1", "2"].includes(item?.code[1]) ? item?.code?.slice(2) : item?.code?.slice(1)) === normalizedCode
  //       );

  //       if (itemIndex !== -1) {
  //         updatedArray[itemIndex] = { ...updatedArray[itemIndex], cof: value };
  //       }

  //       return { ...prev, [correctedType]: updatedArray };
  //     });

  //     checkHAC(code).then((res) => {
  //       const hacExists = res?.data?.code_exists_in_hac ?? res;

  //       setHACStatus((prev) => {
  //         const updated = { ...prev };
  //         String(value) === "2"
  //           ? delete updated[normalizedCode]
  //           : (updated[normalizedCode] = hacExists);
  //         return updated;
  //       });

  //       setHasCode(hacExists && String(value) === "1");
  //       saveToHistory();

  //       setDiagnosisStates((prev) => {
  //         if (!prev || typeof prev !== "object") return prev;

  //         const updated = { ...prev };

  //         for (const key in updated) {
  //           if (!Array.isArray(updated[key])) continue;
  //           updated[key] = updated[key].map((item) =>
  //             normalizeCode(["1", "2"].includes(item?.code[1]) ? item?.code?.slice(2) : item?.code?.slice(1)) === normalizedCode
  //               ? {
  //                   ...item,
  //                   code: `${value}${normalizedCode}`,
  //                   cof: String(value),
  //                 }
  //               : item
  //           );
  //         }

  //         handleAccept(null, null, null, updated);
  //         return JSON.stringify(updated) !== JSON.stringify(prev)
  //           ? updated
  //           : prev;
  //       });
  //     });
  //   };
  // const handleCofSelect = (type, index, value, codeValue) => {
  //  let finalCode = codeValue.slice(2)
  //   const normalizedCode = normalizeCode(finalCode);
  //   // const correctedType = type === "additional" ? "additional_diagnoses" : type;
  //    // FIX: Use the correct key names that match your state structure
  // let correctedType;
  // if (type === "additional") {
  //   correctedType = "additional_diagnoses";
  // } else if (type === "principal") {
  //   correctedType = "principal_diagnosis";
  // } else {
  //   correctedType = "procedure_codes";
  // }


  //   // Update selected COF values
  // // setSelectedCofValues((prev) => {
  // //   const updatedArray = [...(prev[correctedType] || [])];

  // //   const itemIndex = updatedArray.findIndex(
  // //     (item) => normalizeCode(item.code) === normalizedCode
  // //   );

  // //   if (itemIndex !== -1) {
  // //     updatedArray[itemIndex] = {
  // //       ...updatedArray[itemIndex],
  // //       cof: value,
  // //       code: `${value}${normalizedCode}`
  // //     };

  // //   } else {
  // //   }

  // //   return { ...prev, [correctedType]: updatedArray };
  // // });

  // // Update selected COF values
  // setSelectedCofValues((prev) => {
  //   const updatedArray = [...(prev[correctedType] || [])];

  //   if (index >= 0 && index < updatedArray.length) {
  //     const updatedItem = {
  //       ...updatedArray[index],
  //       cof: value,
  //       code: `${value}${normalizedCode}`
  //     };
  //     updatedArray[index] = updatedItem;
  //   } else {
  //     const itemIndex = updatedArray.findIndex(
  //       (item) => item.code.endsWith(normalizedCode)
  //     );

  //     if (itemIndex !== -1) {
  //       const updatedItem = {
  //         ...updatedArray[itemIndex],
  //         cof: value,
  //         code: `${value}${normalizedCode}`
  //       };
  //       updatedArray[itemIndex] = updatedItem;
  //     } else {
  //     }
  //   }

  //   return { ...prev, [correctedType]: updatedArray };
  // });

  //   checkHAC(finalCode).then((res) => {
  //     const hacExists = res?.data?.code_exists_in_hac ?? res;

  //     setHACStatus((prev) => {
  //       const updated = { ...prev };
  //       String(value) === "2"
  //         ? delete updated[normalizedCode]
  //         : (updated[normalizedCode] = hacExists);
  //       return updated;
  //     });

  //     setHasCode(hacExists && String(value) === "1");
  //     saveToHistory();

  //     setDiagnosisStates((prev) => {
  //       if (!prev || typeof prev !== "object") return prev;

  //       const updated = { ...prev };

  //       for (const key in updated) {
  //         if (!Array.isArray(updated[key])) continue;
  //         updated[key] = updated[key].map((item) =>
  //           normalizeCode(item.code) === normalizedCode
  //             ? {
  //                 ...item,
  //                 code: `${value}${normalizedCode}`,
  //                 cof: String(value),
  //               }
  //             : item
  //         );
  //       }

  //       handleAccept(null, null, null, updated);
  //       return JSON.stringify(updated) !== JSON.stringify(prev)
  //         ? updated
  //         : prev;
  //     });
  //   });
  // };

  const applyCOF = (code, value) => {
    if (!code) return code;

    const match = code.match(/^[A-Za-z]+/);
    const prefixLength = match ? match[0].length : 0;

    const idx = code
      .split("")
      .findIndex((ch, i) => i >= prefixLength && (ch === "1" || ch === "2"));

    if (idx === -1) return code;

    return code.slice(0, idx) + String(value) + code.slice(idx + 1);
  };
  const COF_VALUES = new Set(["1", "2", "Y", "N", "U", "W"]);

  const applyCOFUSA = (code, cof) => {
    const baseCode = getBaseCode(code);
    return `${cof}${baseCode}`;
  };

  const stripCOFForAPI = (code) => {
    if (!code) return code;

    const match = code.match(/^[A-Za-z]+/);
    const prefixLength = match ? match[0].length : 0;

    const idx = code
      .split("")
      .findIndex((ch, i) => i >= prefixLength && (ch === "1" || ch === "2"));

    if (idx === -1) return code;

    return code.slice(0, idx) + code.slice(idx + 1);
  };

  const handleCofSelect = (type, index, value, codeValue) => {
    const updatedCode = applyCOF(codeValue, value);
    const normalizedCode = normalizeCode(updatedCode);

    const correctedType = type === "additional" ? "additional_diagnoses" : type;

    setSelectedCofValues((prev) => {
      const updatedArray = [...(prev[correctedType] || [])];

      const itemIndex = updatedArray.findIndex(
        (item) => normalizeCode(applyCOF(item?.code, value)) === normalizedCode,
      );

      if (itemIndex !== -1) {
        updatedArray[itemIndex] = {
          ...updatedArray[itemIndex],
          cof: value,
        };
      }

      return { ...prev, [correctedType]: updatedArray };
    });
    const codeToSendToAPI = ["1", "2"].includes(updatedCode[1])
      ? updatedCode?.slice(2)
      : updatedCode?.slice(1);
    checkHAC(codeToSendToAPI).then((res) => {
      const hacExists = res?.data?.code_exists_in_hac ?? res;

      setHACStatus((prev) => {
        const updated = { ...prev };
        if (String(value) === "2") {
          delete updated[normalizedCode];
        } else {
          updated[normalizedCode] = hacExists;
        }
        return updated;
      });

      setHasCode(hacExists && String(value) === "1");
      saveToHistory();
      setHasCofOrClusterChanged(true);
      setDiagnosisStates((prev) => {
        if (!prev || typeof prev !== "object") return prev;

        const updated = { ...prev };

        for (const key in updated) {
          if (!Array.isArray(updated[key])) continue;

          updated[key] = updated[key].map((item) => {
            const itemNorm = normalizeCode(applyCOF(item.code, value));

            return itemNorm === normalizedCode
              ? {
                  ...item,
                  code: updatedCode,
                  cof: String(value),
                }
              : item;
          });
        }

        // handleAccept(null, null, null, updated);
        if (type === "principal") {
        setTimeout(() => {
          triggerWarnings(updated, "", false, hasPrincipalHAC);
        }, 0);
      }

        return JSON.stringify(updated) !== JSON.stringify(prev)
          ? updated
          : prev;
      });
    });
  };
  const getBaseCode = (code = "") => {
    if (!code) return code;

    const firstChar = code.charAt(0);
    return COF_VALUES.has(firstChar) ? code.slice(1) : code;
  };

  const handleCofSelectUSA = (type, index, value, codeValue) => {
    const baseCode = getBaseCode(codeValue); // stable identity
    const updatedCode = applyCOFUSA(baseCode, value); // apply new COF

    const correctedType = type === "additional" ? "additional_diagnoses" : type;

    /* ---------------- COF STATE ---------------- */
    setSelectedCofValues((prev) => {
      const updatedArray = [...(prev[correctedType] || [])];

      const itemIndex = updatedArray.findIndex(
        (item) => getBaseCode(item.code) === baseCode,
      );

      if (itemIndex !== -1) {
        updatedArray[itemIndex] = {
          ...updatedArray[itemIndex],
          cof: value,
          code: updatedCode,
        };
      }

      return { ...prev, [correctedType]: updatedArray };
    });

    /* ---------------- HAC CHECK ---------------- */
    const codeToSendToAPI = ["1", "2"].includes(updatedCode[1])
      ? updatedCode.slice(2)
      : updatedCode.slice(1);

    checkHAC(codeToSendToAPI).then((res) => {
      const hacExists = res?.data?.code_exists_in_hac ?? res;

      setHACStatus((prev) => {
        const updated = { ...prev };
        const norm = normalizeCode(updatedCode);

        if (String(value) === "2") {
          delete updated[norm];
        } else {
          updated[norm] = hacExists;
        }
        return updated;
      });

      setHasCode(hacExists && String(value) === "1");
      saveToHistory();

      /* ---------------- DIAGNOSIS STATE ---------------- */
      setDiagnosisStates((prev) => {
        if (!prev || typeof prev !== "object") return prev;

        const updated = { ...prev };

        for (const key in updated) {
          if (!Array.isArray(updated[key])) continue;

          updated[key] = updated[key].map((item) =>
            getBaseCode(item.code) === baseCode
              ? {
                  ...item,
                  code: updatedCode,
                  cof: String(value),
                }
              : item,
          );
        }

        handleAccept(null, null, null, updated);

        /* ---------------- UPDATE WARNING MESSAGES FOR PRINCIPAL COF ---------------- */
        if (type === "principal") {
          const codeWithoutCOF = baseCode; // This is the code without the COF prefix
          const newWarning = `Code ${codeWithoutCOF} has COF ${value}. Only COF Y is recommended for Principal diagnosis.`;

          setWarningMessage((prevWarnings) => {
            // First, remove any existing COF warning for this specific code
            const filteredWarnings = prevWarnings.filter((warning) => {
              if (
                warning.includes("has COF") &&
                warning.includes("Only COF Y is recommended")
              ) {
                // Check if this warning is for the same code
                const warningCodeMatch = warning.match(
                  /Code\s+([^\s]+)\s+has\s+COF/,
                );
                if (warningCodeMatch) {
                  const warningCode = warningCodeMatch[1];
                  return warningCode !== codeWithoutCOF;
                }
              }
              return true; // Keep all other warnings
            });

            // If value is not 'Y', add the new COF warning
            if (value !== "Y" && value !== "y") {
              return [newWarning, ...filteredWarnings];
            }

            // If value is 'Y', just return filtered warnings (COF warning removed)
            return filteredWarnings;
          });
        }

        return updated;
      });
    });
  };

  const handlePopupConfirm = async () => {
    if (!pendingCode || !pendingType) return;
    // fetchData1();
    setModalVisible(false);
    setPendingCode("");
    setPendingType("");
  };
  useEffect(() => {
    const creationepisodeIdentifier = location.state?.hcp_line_id;
    if (creationepisodeIdentifier) return;
    // Skip if user came from "auditor"
    if (fromLocation === "auditor" || fromLocation === "coder") return;

    const newHcpLineId = episodeListData?.selectedEpisode?.hcp_line_id;

    if (
      !newHcpLineId ||
      newHcpLineId === sessionStorage.getItem("last_hcp_line_id")
    )
      return;

    // setDiagnosisStates({ principal: [], additional: [], procedure: [] });
    setEnteredCode({
      principalCode: "",
      additionalCode: "",
      procedureCode: "",
    });

    sessionStorage.setItem("last_hcp_line_id", newHcpLineId);
    sessionStorage.setItem(
      "last_epi_identifier",
      episodeListData?.selectedEpisode?.episode_identifier,
    );
    sessionStorage.setItem(
      "case_mix_speciality",
      episodeListData?.selectedEpisode?.speciality,
    );
    sessionStorage.removeItem("principalDiagnosisState");
    sessionStorage.removeItem("additionalDiagnosisState");
    sessionStorage.removeItem("procedureCodesState");
  }, [episodeListData?.selectedEpisode?.hcp_line_id, fromLocation]);

  useEffect(() => {
    sessionStorage.setItem("diagnosisStates", JSON.stringify(diagnosisStates));
  }, [diagnosisStates]);
  useEffect(() => {
    dispatch(updateAcsCode(null));
    if (lastHcpLineId) {
      setHcpLineId(lastHcpLineId);
    }
    sessionStorage.setItem("isConfirmed", false);
  }, [lastHcpLineId]);
  //const lastHcpLineId = sessionStorage.getItem("last_hcp_line_id");
useEffect(() => {
  // HAC check always runs
  if (
    Array.isArray(diagnosisStates?.principal) &&
    diagnosisStates.principal.length > 0
  ) {
    const hasHAC = diagnosisStates.principal
      .filter(Boolean)
      .some((item) => hacStatus?.[normalizeCode(item.code)] === true);

    setHasPrincipalHAC(hasHAC);
  }

  if (!drgValue || skipAcceptApi) return;

  // Skip while batch inserting
  if (isBatchInsertingRef.current) return;
  // if (isSuppressedRef.current) return;

  // During normal manual changes
  if (!batchInsertCompleted) {
    handleAccept(null, null, null, diagnosisStates);
    return;
  }

  // Batch completed → call ONCE
  handleAccept(null, null, null, diagnosisStates);

  triggerWarnings(diagnosisStates, "", false,hasPrincipalHAC);

  setBatchInsertCompleted(false);
}, [diagnosisStates, hacStatus, batchInsertCompleted]);
// useEffect(() => {
//   if (!hasPrincipalHAC) return; // ← only run when HAC is true
//   triggerWarnings(diagnosisStates, "", false, hasPrincipalHAC);
// }, [hasPrincipalHAC]);
const handleDelete = async (type, index) => {
  if (isLockedCoder) {
    toast.error("Episode is locked.");
    return;
  }
  saveToHistory();

  const currentList = diagnosisStates[type];
  const deletedCodeForInserted =
    type === "procedure"
      ? currentList[index]?.code?.trim()
      : isDCID
        ? currentList[index]?.code?.trim().slice(2)
        : currentList[index]?.code?.trim().slice(1);

  const prev = diagnosisStates;
  const updatedCodes = [...prev[type]];

  const deletedCode =
    type === "procedure"
      ? updatedCodes[index]?.code?.trim()
      : isDCID
        ? updatedCodes[index]?.code?.trim().slice(2)
        : updatedCodes[index]?.code?.trim().slice(1);

  let newState;
  let newPrincipalHasHAC = false;

    if (type === "principal" && updatedCodes.length === 1) {
    const additionalCodes = [...prev.additional];
    const [firstAdditional, ...remainingAdditional] = additionalCodes;
    const newPrincipal = firstAdditional ? [firstAdditional] : [];

    newState = {
      ...prev,
      principal: newPrincipal,
      additional: remainingAdditional,
    };

    if (deletedCode) {
      const normalizedDeletedCode = deletedCode.replace(/^[12]/, "");
      setHACStatus((prevHAC) => {
        if (!prevHAC || typeof prevHAC !== "object") return prevHAC;
        const updatedHAC = { ...prevHAC };
        delete updatedHAC[normalizedDeletedCode];
        return updatedHAC;
      });
    }

    const newHACStatus = { ...hacStatus };
    if (deletedCode) delete newHACStatus[deletedCode.replace(/^[12]/, "")];

    newPrincipalHasHAC = newPrincipal // ✅ assign instead of const
      .filter(Boolean)
      .some((item) => newHACStatus?.[normalizeCode(item.code)] === true);

    setHasPrincipalHAC(newPrincipalHasHAC);

    sessionStorage.setItem(
      "principalDiagnosisState",
      JSON.stringify(newState.principal),
    );
    sessionStorage.setItem(
      "additionalDiagnosisState",
      JSON.stringify(newState.additional),
    );
  } else {
    updatedCodes.splice(index, 1);
    newState = { ...prev, [type]: updatedCodes };

    if (deletedCode) {
      setHACStatus((prevHAC) => {
        if (!prevHAC || typeof prevHAC !== "object") return prevHAC;
        const updatedHAC = { ...prevHAC };
        delete updatedHAC[deletedCode.replace(/^[12]/, "")];
        return updatedHAC;
      });
    }

    // ✅ If deleting from principal, reset hasPrincipalHAC immediately
    if (type === "principal") {
      setHasPrincipalHAC(false);
    }

    sessionStorage.setItem(
      `${type}DiagnosisState`,
      JSON.stringify(updatedCodes),
    );
  }

  if (deletedCode) {
    setDeletedCodes((prev) => [
      ...prev,
      deletedCode.replace(/^[12]/, "").toUpperCase(),
    ]);
  }

  skipAcceptOnStateChange.current = true;
  setDiagnosisStates(newState);
  await handleAccept(null, null, null, newState);
  triggerWarnings(newState, "", false, newPrincipalHasHAC);

  if (deletedCodeForInserted) {
    const normalizedDeletedForInserted = deletedCodeForInserted
      .replace(/^[12]/, "")
      .toUpperCase();
    setNewlyInsertedCodes((prev) =>
      prev.filter(
        (code) => code.toUpperCase() !== normalizedDeletedForInserted,
      ),
    );
  }

  setEnteredCode((prev) => ({ ...prev, [type]: "" }));
};

  const handleCodebookClick = (code, codeKey) => {
    setTimeout(() => {
      dispatch(setRawSearchQuery(code));
    }, 100);
    setCodeBookCard(true);
    setSelectedCodeBookCode(code);
    setSelectedTabKeyCoding(codeKey);
  };

const isValidItem = (item) => item?.code && item.code.trim() !== "";

useEffect(() => {
   if (isBatchInsertingRef.current) return;
  //  if (isSuppressedRef.current) return;
  const debouncedCalculateDrg = debounce(async () => {
    if (skipAPI) {
      setSkipAPI(false);
      return;
    }
    await calculate_drg();
  }, 300);

  debouncedCalculateDrg();


   const alphabetIDs = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
  );

  const doubleAlphabetIDs = alphabetIDs.map((ch) => ch + ch);
  const allClusterIDs = [...alphabetIDs, ...doubleAlphabetIDs];

  dispatch(setClusterIDs(allClusterIDs));

  const principal = diagnosisStates?.principal ?? [];
  const additional = diagnosisStates?.additional ?? [];

  const validPrincipal = principal.filter(isValidItem);
  const validAdditional = additional.filter(isValidItem);

  // console.log(validPrincipal, validAdditional, 'validAdditional')
  if (validPrincipal.length === 0 && validAdditional.length === 0) {
    dispatch(setcurrentClusterID("A"));
    return;
  }

  const usedClusters = [
    ...validPrincipal.map((i) => i.code.match(/^[A-Z]{1,2}/)?.[0]),
    ...validAdditional.map((i) => i.code.match(/^[A-Z]{1,2}/)?.[0]),
  ].filter(Boolean);

  const uniqueUsedClusters = [...new Set(usedClusters)];

  const nextCluster = allClusterIDs.find(
    (id) => !uniqueUsedClusters.includes(id)
  );

  if (nextCluster) {
    dispatch(setcurrentClusterID(nextCluster));
  }
  if (batchInsertCompleted) {
    setBatchInsertCompleted(false);
  }

    return () => {
      debouncedCalculateDrg.cancel();
    };
  }, [diagnosisStates,batchInsertCompleted]);

useEffect(() => {
  if (!showCodeSearch) {

    isSuppressedRef.current = true;
    const timer = setTimeout(() => {
      isSuppressedRef.current = false;
    }, 2000);

    return () => clearTimeout(timer);
  }
}, [showCodeSearch]);

  // useEffect(() => {
  //   if (!drgValue || skipAcceptApi) return;
  //   if (skipAcceptOnStateChange.current) {
  //     skipAcceptOnStateChange.current = false;
  //     return;
  //   }

  //   handleAccept(null, null, null, diagnosisStates);
  // }, [drgValue]); // Runs **only when drgValue updates**

  function applyDynamicDivHeights(types = []) {
    let totalAvailableHeight = 0;

    // Screen width-based height logic
    if (
      window.matchMedia("(min-width: 1400px) and (max-width: 1599px)").matches
    ) {
      totalAvailableHeight = typeOfPatient === "outPatient" ? 400 : 250;
    } else if (
      window.matchMedia("(min-width: 1600px) and (max-width: 1750px)").matches
    ) {
      totalAvailableHeight = 290;
    } else if (
      window.matchMedia("(min-width: 1759px) and (max-width: 1919px)").matches
    ) {
      totalAvailableHeight = 430;
    } else if (
      window.matchMedia("(min-width: 1920px) and (max-width: 2099px)").matches
    ) {
      totalAvailableHeight = 440;
    } else if (
      window.matchMedia("(min-width: 2100px) and (max-width: 2200px)").matches
    ) {
      totalAvailableHeight = 530;
    } else if (
      window.matchMedia("(min-width: 2201px) and (max-width: 2559px)").matches
    ) {
      totalAvailableHeight = 590;
    } else if (
      window.matchMedia("(min-width: 2560px)and (max-width: 2900px)").matches
    ) {
      totalAvailableHeight = 765;
    } else if (window.matchMedia("(min-width:2901px)").matches) {
      totalAvailableHeight = 860;
    } else {
      return; // Exit if screen doesn't match any targeted size
    }

    // Step 1: Check for the warning container and adjust totalAvailableHeight
    const warningContainer = document.querySelector(".warning-main");
    if (
      warningContainer &&
      window.getComputedStyle(warningContainer).display !== "none"
    ) {
      const warningHeight =
        warningContainer.scrollHeight || warningContainer.offsetHeight || 0;
      totalAvailableHeight = Math.max(
        totalAvailableHeight - warningHeight,
        120,
      ); // Ensure a minimum height of 100px
    }

    // Step 2: Get content blocks
    const contentBlocks = types
      .map((type) => {
        const el = document.getElementById(`codingscreen-subtitle1-${type}`);
        return {
          type,
          el,
          scrollHeight: el?.scrollHeight || 0,
        };
      })
      .filter(({ el }) => el);

    if (contentBlocks.length === 0) return;

    // Step 3: If total content height is less than available height, fit content naturally
    const totalUsedHeight = contentBlocks.reduce(
      (sum, block) => sum + block.scrollHeight,
      0,
    );
    if (totalUsedHeight <= totalAvailableHeight) {
      contentBlocks.forEach(({ el, scrollHeight }) => {
        el.style.maxHeight = `${scrollHeight}px`;
        el.style.overflowY = "visible";
      });
      return;
    }

    // Step 4: Start with equal height allocation
    const equalHeight = Math.floor(totalAvailableHeight / contentBlocks.length);

    // Step 5: First pass - allocate equal heights and check if content fits
    let remainingHeight = totalAvailableHeight;
    const allocatedHeights = contentBlocks.map((block) => {
      const neededHeight = Math.min(block.scrollHeight, equalHeight);
      remainingHeight -= neededHeight;
      return { ...block, allocatedHeight: neededHeight };
    });

    // Step 6: Redistribute remaining height to divs that need more
    const blocksNeedingMore = allocatedHeights.filter(
      (block) => block.allocatedHeight < block.scrollHeight,
    );
    if (blocksNeedingMore.length > 0 && remainingHeight > 0) {
      const extraHeightPerBlock = Math.floor(
        remainingHeight / blocksNeedingMore.length,
      );
      blocksNeedingMore.forEach((block) => {
        block.allocatedHeight += extraHeightPerBlock;
      });
    }

    // Step 7: Apply final heights and scrolling
    allocatedHeights.forEach(({ el, allocatedHeight, scrollHeight }) => {
      el.style.maxHeight = `${allocatedHeight}px`;
      el.style.overflowY = allocatedHeight < scrollHeight ? "auto" : "visible";
    });
  }
  useEffect(() => {
    const types = ["additional", "procedure"];
    applyDynamicDivHeights(types);

    const onResize = () => applyDynamicDivHeights(types);
    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, [diagnosisStates]); // or whatever triggers re-render

  const renderDiagnosisSection = (type, label) => {
    const isCodingDisabled =
      codeBookLoading ||
      (selectedCodebookVersion === "12th" && !isFetched12) ||
      (selectedCodebookVersion === "13th" && !isFetched13);
    const principalCount = type === "additional" ? (diagnosisStates?.principal?.filter(i => i?.code)?.length ?? 0) : 0;
    const isInputDisabled = isCodingDisabled || codeValidationisLoading;
    return (
      <>
        <div className={label.replace(/\s+/g, "-").toLowerCase()}>
          <p className="coding-screen-title">{label}</p>
          <div
            id={`codingscreen-subtitle1-${type}`}
            className="codingscreen-subtitle mt-3"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) =>
              codebookusaEnv ? handleDropUSA(e, type) : handleDrop(e, type)
            }
          >
            <Droppable droppableId={type} isDropDisabled={isLockedCoder}>
              {(provided) => (
                <div
                  style={{
                    padding: "0.5px",
                  }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {(diagnosisStates?.[type] ?? [])
                    .filter((item) => item?.code) // removes null / undefined / invalid items
                    .map((item, index) => (
                      <DraggableItem
                        key={`${type}-${item.code}-${index}`}
                        item={item}
                        type={type}
                        index={index}
                        displayNumber={principalCount + index + 1} 
                        accepted={acceptedCodes}
                        handleAccept={handleAccept}
                        handleDelete={handleDelete}
                        handleCodebookClick={handleCodebookClick}
                        handleCofSelect={
                          codebookusaEnv ? handleCofSelectUSA : handleCofSelect
                        }
                        selectedCofValues={selectedCofValues}
                        codingscreendata={codingscreendata}
                        iconDisplay={iconDisplay}
                        newlyInsertedCodes={newlyInsertedCodes}
                        handleAcceptCodes={handleAcceptCodes}
                        hacStatus={hacStatus}
                        hasCode={hasCode}
                        drgConfirmedStatusUpdate={drgConfirmedStatusUpdate}
                        diagnosisStates={diagnosisStates}
                        setDiagnosisStates={setDiagnosisStates}
                        onCofOrClusterChange={() => setHasCofOrClusterChanged(true)}
                      />
                    ))}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            <div className="input-container">
              <input
                type="text"
                ref={(el) => (inputRefList.current[type] = el)}
                className={`coding-screen-input ${
                  errorMessage[type] ? "error-border" : ""
                }`}
                disabled={isInputDisabled}
                name={type}
                placeholder={getErrorMessage(errorMessage, type, searchBy)}
                // placeholder={isCodingDisabled ? "Preparing coding workspace..." : getErrorMessage(errorMessage, type, searchBy)}
                value={enteredCode[type]}
                onChange={(e) => {
                  if (isLockedCoder) {
                    toast.error("Episode is locked.");
                    return;
                  }
                  handleCodeChange(e, type, searchBy);
                  setSearchOptionsDropdown(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    codebookusaEnv
                      ? handleCodeInsertionUSA(
                          e.target.value.toUpperCase(),
                          type,
                        )
                      : handleCodeInsertion(e.target.value.toUpperCase(), type);
                    e.preventDefault();
                  }
                }}
                onFocus={() => {
                  setErrorMessage((prev) => ({ ...prev, [type]: "" }));
                  setSearchOptionsDropdown(true);
                  setActiveSection(type);
                  setRecommendations([]);
                  setShowDropdown(false);
                }}
                onBlur={() =>
                  setErrorMessage((prev) => ({ ...prev, [type]: "" }))
                }
              />
              {errorMessage[type] && (
                <span className="error-message">{errorMessage[type]}</span>
              )}
            </div>
          </div>
        </div>
        {activeSection === type && searchOptionsDropdown && !showDropdown && (
          <div
            className={`dropdown reccomendations-dropdown ${type}`}
            ref={searchOptionsRef}
          >
            <div className="reccomendations-items-suggestions">
              <p>Search By...</p>
              <span
                onClick={() => {
                  setSearchBy("Code");
                  setTimeout(() => {
                    inputRefList.current[type]?.focus();
                    setSearchOptionsDropdown(false); // move inside timeout
                  }, 0);
                }}
              >
                Code
              </span>
              <span
                onClick={() => {
                  setSearchBy("Description");
                  setTimeout(() => {
                    inputRefList.current[type]?.focus();
                    setSearchOptionsDropdown(false); // move inside timeout
                  }, 0);
                }}
              >
                Description
              </span>
            </div>
          </div>
        )}
        {activeSection === type && showDropdown && (
          <div
            className={`dropdown reccomendations-dropdown ${type}`}
            ref={dropdownRef}
          >
            {isLoading ? (
              <div>Loading...</div>
            ) : (
              recommendations.codes.map((item, index) => (
                <div
                  className="reccomendations-items"
                  key={index}
                  onClick={() => handleSelectRecommendation(item, type)}
                >
                  <span style={{ color: "#000000" }}>
                    {typeof item?.code === "string" && item.code.includes("(")
                      ? item.code.slice(0, item.code.indexOf("("))
                      : (item?.code ?? "")}
                  </span>

                  <span style={{ color: "#252c32" }}>{item.description}</span>
                </div>
              ))
            )}
          </div>
        )}
      </>
    );
  };


  const handleDragEnd = async (result) => {
    setSkipAPI(true);
    const { source, destination } = result;
    if (!destination) {
      setIsAnimation(false);
      return;
    }

    let updatedState;
    let cofWarning = null;

    await new Promise((resolve) => {
      setDiagnosisStates((prev) => {
        if (!prev) return prev;

        const sourceType = source.droppableId;
        const destinationType = destination.droppableId;

        if (
          (sourceType === "procedure" && destinationType !== "procedure") ||
          (destinationType === "procedure" && sourceType !== "procedure")
        ) {
          toast.warning("Moving items to or from 'Procedure' is not allowed!");
          return prev;
        }

        if (
          sourceType === destinationType &&
          source.index === destination.index
        ) {
          return prev;
        }

        const sourceItems = (prev[sourceType] || []).filter(
          (item) => item && item.code,
        );

        const destinationItems =
          sourceType === destinationType
            ? sourceItems
            : (prev[destinationType] || []).filter((item) => item && item.code);

        const [movedItem] = sourceItems.splice(source.index, 1);
        updatedState = { ...prev };

        const getCOFValue = (code) => {
          if (!code) return null;
          return code.charAt(0); // Y / 1 / 2
        };

        // Check if moved to principal and has COF Y
        const cof = getCOFValue(movedItem.code);

        if (sourceType === "additional" && destinationType === "principal") {
          if (isCodeRestricted(movedItem.code)) {
            toast.warning(
              `Code is restricted and cannot be added to the Principal section.`,
            );
            return prev;
          }

          if (cof !== "Y" && codebookusaEnv) {
            cofWarning = `Code ${movedItem.code.slice(
              1,
            )} has COF ${cof}. Only COF Y is recommended for Principal diagnosis.`;
          }

          const hasPrincipal = prev.principal?.length > 0;

          updatedState = {
            ...prev,
            principal: [movedItem],
            additional: hasPrincipal
              ? [prev.principal[0], ...sourceItems].filter(
                  (item) => item && item.code,
                )
              : [],
          };

          setSkipAPI(false);
        } else if (
          sourceType === "principal" &&
          destinationType === "additional"
        ) {
          const firstAdditional = prev.additional?.[0] || null;
          updatedState = {
            ...prev,
            principal: firstAdditional ? [firstAdditional] : [],
            additional: firstAdditional
              ? [movedItem, ...prev.additional.slice(1)]
              : [movedItem],
          };
          setSkipAPI(false);
        } else {
          destinationItems.splice(destination.index, 0, movedItem);
          updatedState = {
            ...prev,
            [sourceType]: sourceItems,
            [destinationType]: destinationItems,
          };
        }
        handleAccept(null, null, null, updatedState)
          .then(resolve)
          .catch(() => setIsAnimation(false));
        return updatedState;
      });
      resolve();
    });

    // Now call saveToHistory AFTER diagnosisStates has been updated
    setTimeout(() => {
      saveToHistory(); // Use structuredClone or cloneDeep here
    }, 0);
    setTimeout(() => {
      if (!updatedState) return;

      triggerWarnings(updatedState, "", false, hasPrincipalHAC);
    }, 0);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };
  const handleSelectRecommendation = (selectedValue, type) => {

    setEnteredCode((prev) => ({
      ...prev,
      [type]: selectedValue.code,
    }));
    setShowDropdown(false);
  };

  const findTabularChildren = useCallback(
    (
      items,
      normalizedCode,
      results = [],
      found = { value: false },
      extraOptionToIdentify = null,
    ) => {
      const isRange = normalizedCode?.includes("-");
      let rangeStart, rangeEnd;

      if (isRange) {
        const parts = normalizedCode
          .split("-")
          .map((c) => c.trim()?.toUpperCase());
        [rangeStart, rangeEnd] = [parts[0], parts[1]];
      } else {
        normalizedCode = normalizedCode?.toUpperCase();
      }

      const createResultItem = (item, isChild = false) => ({
        rawName: item.name,
        rawDescription: item.description,
        name: item.name,
        description: item.description,
        children: item.subcodes || item.children || [],
        isFromTabular: true,
        id: item.id,
        acs: item.acs,
        nca: item.nca,
        ...(extraOptionToIdentify &&
          !isChild && {
            code_first_instruction: item.code_first_instruction,
            use_additional_instruction: item.use_additional_instruction,
          }),
        codealsowhenperf_instruction: item.codealsowhenperf_instruction,
      });
      const compareCodes = (code, start, end) => {
        // Convert to comparable string: remove dots and uppercase
        const c = code.replace(/\./g, "").toUpperCase();
        const s = start.replace(/\./g, "").toUpperCase();
        const e = end.replace(/\./g, "").toUpperCase();
        return c >= s && c <= e;
      };
      const isInRange = (code) => {
        if (!isRange) return false;
        return rangeEnd
          ? compareCodes(code, rangeStart, rangeEnd)
          : code.startsWith(rangeStart);
      };
      for (const item of items) {
        if (found.value) break;

        // Handle chapters
        if (item.chapter && item.codes) {
          const chapterCode = item.chapter?.replace(/\./g, "")?.toUpperCase();
          if (!isRange && chapterCode === normalizedCode) {
            findTabularChildren(
              item.codes,
              normalizedCode,
              results,
              found,
              extraOptionToIdentify,
            );
            found.value = true;
            return results;
          }
          continue;
        }

        const itemCode = item.name;
        if (!itemCode) continue;

        const itemCodeNormalized = itemCode.replace(/\./g, "").toUpperCase();
        const matches =
          itemCodeNormalized === normalizedCode ||
          isInRange(itemCodeNormalized);

        if (matches) {
          const itemChildren = item.subcodes || item.children || [];
          const targets = itemChildren.length > 0 ? itemChildren : [item];

          targets.forEach((target) =>
            results.push(createResultItem(target, itemChildren.length > 0)),
          );
          found.value = true;
        }

        // Recurse deeper if not found
        if (!found.value) {
          [item.codes, item.subcodes, item.children]
            .filter(Boolean)
            .forEach((nested) =>
              findTabularChildren(
                nested,
                normalizedCode,
                results,
                found,
                extraOptionToIdentify,
              ),
            );
        }
      }
      return results;
    },
    [],
  );

  const filterTabularCodes = useCallback(
    (baseCode, category) => {
      // if (category === "Procedure Codes") return [];
      const normalizedCode = baseCode.replace(/\./g, "").toLowerCase();
      const tabularData =
        category === "Procedure Codes"
          ? achiTabularData13
          : icd10amTabularData13;
      return findTabularChildren(tabularData || [], normalizedCode);
    },
    [icd10amTabularData13, achiTabularData13, findTabularChildren],
  );

  const getAllCodesWithHierarchy = useCallback((code, depth = 0) => {
    if (!code) return [];

    let allCodes = [];

    // Add the current code itself
    allCodes.push({
      ...code,
      _depth: depth,
      _isRangeCode: true,
      _isParentNode:
        (code.children && code.children.length > 0) ||
        (code.subcodes && code.subcodes.length > 0),
    });

    // Recursively process subcodes (this is where intermediate parents like S00.0 are)
    if (code.subcodes && code.subcodes.length > 0) {
      code.subcodes.forEach((subcode) => {
        const subcodeResults = getAllCodesWithHierarchy(subcode, depth + 1);
        allCodes = [...allCodes, ...subcodeResults];
      });
    }

    // Recursively process children
    if (code.children && code.children.length > 0) {
      code.children.forEach((child) => {
        const childResults = getAllCodesWithHierarchy(child, depth + 1);
        allCodes = [...allCodes, ...childResults];
      });
    }
    return allCodes;
  }, []);

  const getAllCodesFromRange = useCallback(
    (rangeCode, category) => {

      // First, get the main range children
      const rangeChildren = filterTabularCodes(rangeCode, category);

      if (!rangeChildren || rangeChildren.length === 0) {
        return [];
      }

      let allCodes = [];

      // For each child in the range, get complete hierarchy
      rangeChildren.forEach((child) => {
        const hierarchyCodes = getAllCodesWithHierarchy(child);
        allCodes = [...allCodes, ...hierarchyCodes];
      });

      // Remove duplicates based on ID while preserving hierarchy
      const uniqueCodes = allCodes.filter(
        (code, index, self) =>
          index === self.findIndex((c) => c.id === code.id),
      );

      // Log the hierarchy for debugging
    

      return uniqueCodes;
    },
    [filterTabularCodes, getAllCodesWithHierarchy],
  );

  const fetchAndStoreRangeChildren = useCallback(
    (filterTabularCodes, selectedCategory = "Principal Diagnosis") => {
      

      const ranges = [
        {
          code: "S00-S09,S10-S29,S20-S29,S30-S39,S40-S49,S50-S59,S60-S69,S70-S79,S80-S89,S90-S99,T00-T07,T08-T14,T15-T19,T20-T31,T33-T35,T36-T50,T51-T65",
          name: "Injury Codes with Activity",
          stateKey: "injuryWithActivity",
        },
        {
          code: "V00-X59,X60-X84,X85-Y09,Y10-Y34,Y35-Y36,Y37-Y37,Y40-Y84,Y85-Y89,Y90,Y91,Y95,Y96,Y97,Y98",
          name: "External Cause Codes",
          stateKey: "externalCauseCodes",
        },
        {
          code: "Y92.0,Y92.1,Y92.2,Y92.3,Y92.4,Y92.5,Y92.6,Y92.7,Y92.8",
          name: "Place of Occurrence",
          stateKey: "placeOfOccurrence",
        },
        {
          code: "U50-U72,U73.0,U73.1,U73.2,U73.81,U73.8, U73.9",
          name: "Activity Codes",
          stateKey: "activityCodes",
        },
        {
          code: "T66-T78,T79-T79,T80-T88,T89-T89,T90-T98",
          name: "Injury Codes without Activity",
          stateKey: "injuryWithoutActivity",
        },
        {
          code: "S00-S09,S10-S29,S20-S29,S30-S39,S40-S49,S50-S59,S60-S69,S70-S79,S80-S89,S90-S99,T00-T07,T08-T14",
          name: "injuries",
          stateKey: "injuries",
        },
        {
          code: "T20-T31",
          name: "burns",
          stateKey: "burns",
        },
        {
          code: "T33-T35",
          name: "frostbite",
          stateKey: "frostbite",
        },
        {
          code: "T33-T35",
          name: "poisoning",
          stateKey: "poisoning",
        },
        {
          code: "T66-T78",
          name: "effectsOfExternalCauses",
          stateKey: "effectsOfExternalCauses",
        },
        {
          code: "T79-T79",
          name: "earlyComplicationsOfTrauma",
          stateKey: "earlyComplicationsOfTrauma",
        },
        {
          code: "T80-T88",
          name: "complicationOfSurgicalAndMedicalCare",
          stateKey: "complicationOfSurgicalAndMedicalCare",
        },
        {
          code: "T89-T89",
          name: "otherComplicationOfTrauma",
          stateKey: "otherComplicationOfTrauma",
        },
        {
          code: "T90-T98",
          name: "sequelaeOfInjuries",
          stateKey: "sequelaeOfInjuries",
        },
        {
          code: "U78-U88",
          name: "chronicCodes",
          stateKey: "chronicCodes",
        },
      ];

      let totalCodes = 0;
      let parentCount = 0;
      let childCount = 0;

      // Process each range
      ranges.forEach((range, rangeIndex) => {
        try {
          // console.group(
          //   ` Processing ${range.name} (${range.code}) - ${rangeIndex + 1}/${
          //     ranges.length
          //   }`
          // );

          const rangeParts = range.code.split(",");
          let allCodes = [];
          rangeParts.forEach((part, i) => {
            try {
              const rangeCodes = getAllCodesFromRange(part, selectedCategory);

              if (rangeCodes && rangeCodes.length > 0) {
                allCodes = [...allCodes, ...rangeCodes];
              } else {
                console.log(`No codes found in this part`);
              }
            } catch (err) {
              console.error("❌ Error for part:", part, err);
            }
          });

          // Count parents and children
          const parentsInRange = allCodes.filter(
            (code) => code._isParentNode,
          ).length;
          const childrenInRange = allCodes.filter(
            (code) => !code._isParentNode,
          ).length;

          parentCount += parentsInRange;
          childCount += childrenInRange;
          // Store in Redux
          dispatch(
            setRangeChildren({
              rangeType: range.stateKey,
              children: allCodes,
            }),
          );

          totalCodes += allCodes.length;

         
          // console.groupEnd();
        } catch (error) {
          // console.error(`Error loading range ${range.name}:`, error);
          console.groupEnd();
        }
      });

    },
    [dispatch, getAllCodesFromRange],
  );

  useEffect(() => {
    const fetchRanges = () => {
      // Check if tabular data is available
      const hasTabularData = icd10amTabularData13 && achiTabularData13;

      if (hasTabularData) {
        fetchAndStoreRangeChildren("Principal Diagnosis");
      }
    };

    // Use a small delay to ensure everything is loaded
    const timer = setTimeout(fetchRanges, 1000);
    return () => clearTimeout(timer);
  }, [
    icd10amTabularData13,
    achiTabularData13,
    fetchAndStoreRangeChildren,
    filterTabularCodes,
  ]);

  const processDiagnosisList = (list = []) => {
    return list.map((item) => {
      const originalCode = item?.code;

      if (!originalCode) return item;

      if (!["1", "2"].includes(originalCode[0])) {
        return item;
      }

      const codeToPass = originalCode.slice(1);

      const prevCOF = originalCode[0];

      const processedCode = checkTypeOfCode(codeToPass);

      const finalCode =
        processedCode?.length > 1
          ? `${processedCode[0]}${prevCOF}${processedCode.slice(1)}`
          : processedCode;

      return {
        ...item,
        code: finalCode,
      };
    });
  };

  // useEffect(() => {
  //   const hasRequiredCodes =
  //     activityCodes?.length ||
  //     externalCauseCodes?.length ||
  //     placeOfOccurrence?.length ||
  //     injuryWithActivity?.length ||
  //     injuryWithoutActivity?.length ||
  //     chronicCodes?.length;

  //   if (!hasRequiredCodes) return;

  //   if (codingscreendata?.data?.meta?.is_DCID === true) {
  //     const principalCodes = processDiagnosisList(diagnosisStates?.principal);
  //     const additionalCodes = processDiagnosisList(diagnosisStates?.additional);
  //     setDiagnosisStates((prev) => ({
  //       ...prev,
  //       principal: principalCodes,
  //       additional: additionalCodes,
  //     }));
  //   }
  // }, [
  //   activityCodes,
  //   externalCauseCodes,
  //   placeOfOccurrence,
  //   injuryWithActivity,
  //   injuryWithoutActivity,
  //   chronicCodes,
  // ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideDropdown =
        !dropdownRef.current || !dropdownRef.current.contains(event.target);

      const clickedOutsideSearchOptions =
        !searchOptionsRef.current ||
        !searchOptionsRef.current.contains(event.target);
      const clickedOutsideInputs = !Object.values(inputRefList.current).some(
        (ref) => ref && ref.contains(event.target),
      );

      if (
        clickedOutsideDropdown &&
        clickedOutsideSearchOptions &&
        clickedOutsideInputs
      ) {
        setShowDropdown(false);
        setRecommendations([]);
        setSearchOptionsDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const checkPrincipalCodePrefix = (principalCodes) => {
    if (!principalCodes || principalCodes.length === 0) return null;

    const principalCode = principalCodes[0]?.code;
    if (!principalCode) return null;

    // Check if principal code starts with 'Y'
    const firstChar = principalCode.charAt(0);
    if (firstChar !== "Y") {
      return `Code ${principalCode.slice(
        1,
      )} has COF N. Only COF Y is recommended for Principal diagnosis.`;
    }

    return null;
  };

  useEffect(() => {
    setHasCofOrClusterChanged(false);
    if (!codingscreendata?.data) return;
    

    const {
      principal_diagnosis = [],
      additional_diagnoses = [],
      procedure_codes = [],
    } = codingscreendata.data;

    const withCof = (arr) =>
      arr?.map(({ code }) => ({ code, cof: code?.charAt(0) })) || [];

    setSelectedCofValues({
      principal_diagnosis: withCof(principal_diagnosis),
      additional_diagnoses: withCof(additional_diagnoses),
      procedure_codes: withCof(procedure_codes),
    });
    const principalCodes = processDiagnosisList(principal_diagnosis);
    const additionalCodes = processDiagnosisList(additional_diagnoses);

   if(codingscreendata?.data?.meta?.is_DCID === true){
     setDiagnosisStates({
      principal: principalCodes,
      additional: additionalCodes,
      procedure: procedure_codes,
    });
   }else{
      setDiagnosisStates({
        principal: principal_diagnosis,
        additional: additional_diagnoses,
        procedure: procedure_codes,
      });
   }

    sessionStorage.setItem(
      "principalDiagnosisState",
      JSON.stringify(principal_diagnosis),
    );
    sessionStorage.setItem(
      "additionalDiagnosisState",
      JSON.stringify(additional_diagnoses),
    );
    sessionStorage.setItem(
      "procedureCodesState",
      JSON.stringify(procedure_codes),
    );

    const allCodes = [
      ...principal_diagnosis,
      ...additional_diagnoses,
      ...procedure_codes,
    ];

    // Check principal code prefix
    const principalPrefixWarning =
      checkPrincipalCodePrefix(principal_diagnosis);
    let allWarnings = [];
    // Combine all warnings
    if (codebookusaEnv) {
      allWarnings = [
        ...(principalPrefixWarning ? [principalPrefixWarning] : []),
      ];
    }

    checkCofWarnings(codingscreendata);
    setWarningMessage(allWarnings.length ? allWarnings : []);
  }, [codingscreendata]);
  useEffect(() => {
    if (!codingscreendata?.data) return;

    const isDCID = codingscreendata?.data?.meta?.is_DCID === true;

    const {
      principal_diagnosis = [],
      additional_diagnoses = [],
      procedure_codes = [],
    } = codingscreendata.data;

    const principalCodes = processDiagnosisList(principal_diagnosis);
    const additionalCodes = processDiagnosisList(additional_diagnoses);

    if (isDCID && !principalCodes?.length && !additionalCodes?.length) return;

    const finalPrincipal = isDCID ? principalCodes : principal_diagnosis;
    const finalAdditional = isDCID ? additionalCodes : additional_diagnoses;

    sessionStorage.setItem(
      "initialprincipalDiagnosisState",
      JSON.stringify(finalPrincipal),
    );
    sessionStorage.setItem(
      "initialadditionalDiagnosisState",
      JSON.stringify(finalAdditional),
    );

    sessionStorage.setItem(
      "initialprocedureDiagnosisState",
      JSON.stringify(procedure_codes),
    );
    // Build state-like structure
    const initialState = {
      principal: finalPrincipal || [],
      additional: finalAdditional || [],
      procedure: procedure_codes || [],
    };

    // Trigger warnings
    triggerWarnings(initialState, "", true,hasPrincipalHAC);
  }, [lastHcpLineId, codingscreendata?.data]);

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("initialprincipalDiagnosisState");
      sessionStorage.removeItem("initialadditionalDiagnosisState");
      sessionStorage.removeItem("initialprocedureDiagnosisState");
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []);

  useEffect(() => {
    if (!isLastHCPLineIDPresent) {
      toast.warning(
        "Please select an episode from the Episode List to begin coding.",
      );
    }
    return () => {
      toast.dismiss();
      dispatch(resetIsPallasAlgoApplied());
      // sessionStorage.removeItem("initialDiagnosisState")
    };
  }, []);
  const warnings = [
    { message: "Missing patient ID", type: "error" },
    { message: "Missing patient ID", type: "error" },
    { message: "Missing patient ID", type: "warning" },

    { message: "Missing patient ID", type: "error" },
  ];
  const hasStatus = (statusArray, statusName) =>
    statusArray?.some((s) => s.status === statusName);
  const hasActionInProgress =
    (hasStatus(codingscreendata?.data?.meta?.status, "On Hold") &&
      selectedActionType === "onHold") ||
    (hasStatus(codingscreendata?.data?.meta?.status, "For Review") &&
      selectedActionType === "forReview");
  // Add this after your other condition variables
  const isForReviewStatus =
    hasStatus(codingscreendata?.data?.meta?.status, "For Review") ||
    hasStatus(codingscreendata?.data?.meta?.status, "Audit - For Review");

  const shouldDisableForReview =
    isForReviewStatus && newlyInsertedCodes.length === 0 && deletedCodes.length === 0 && !hasCofOrClusterChanged;
  return (
    <>
      {
        // isAnimation || isFetchingData1 ? (
        //   <LdsRoller />
        // ) :
        codingscreendata ? (
          <>
            {/* <Warnings
              warningMessage={warningMessage}
              hasPrincipalHAC={hasPrincipalHAC}
            /> */}
            {codeBookLoading ||
            (selectedCodebookVersion === "12th" && !isFetched12) ||
            (selectedCodebookVersion === "13th" && !isFetched13) ? (
              <div className="google-skeleton">
                <div className="skeleton-line"></div>
              </div>
            ) : isCheckingWarnings ? (
              <div className="warning-loader">
                <span style={{ color: "#b00020", fontSize: "13px" }}>
                  Analyzing code warnings…
                </span>
              </div>
            ) : (
              <WarningStack warnings={warningMessage} />
            )}
            <div
              style={{
                height: "95%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div style={{ height: "79%" }} className="coding-screen-wrapper">
                <div
                  className="coding-screen-label-wrapper"
                  style={{ height: "100%" }}
                >
                  <DragDropContext onDragEnd={handleDragEnd}>
                    {typeOfPatient !== "outPatient" && (
                      <>
                        {" "}
                        {renderDiagnosisSection(
                          "principal",
                          "Principal diagnosis",
                        )}
                        {renderDiagnosisSection(
                          "additional",
                          "Additional diagnoses",
                        )}
                      </>
                    )}
                    {renderDiagnosisSection("procedure", "Procedure codes")}
                  </DragDropContext>
                </div>
              </div>
              <div className="second-container">
                <VentilationInfo
                  codingscreendata={codingscreendata}
                  typeOfPatient={typeOfPatient}
                  handleMvhoursupdation={handleMvhoursupdation}
                  mvHours={mvHours}
                  setMvHours={setMvHours}
                  isLockedCoder={isLockedCoder}
                />
                {drgloading ? (
                  <Loader />
                ) : (
                  location.pathname !== "/Code-Assist" &&
                  location.pathname !== "/Auditor-CodeAssist-Screen" &&
                  !isSmallScreen &&
                  (codeBookLoading ||
                  (selectedCodebookVersion === "12th" && !isFetched12) ||
                  (selectedCodebookVersion === "13th" && !isFetched13) ? (
                    <div className="google-skeleton">
                      <div className="skeleton-line"></div>
                    </div>
                  ) : (
                    <DrgInfo
                      drgData={drgData}
                      setDrgData={setDrgData}
                      selectedVersion={selectedVersion}
                      setSelectedVersion={setSelectedVersion}
                      drgValue={drgValue}
                      weightValue={weightValue}
                      typeOfPatient={typeOfPatient}
                    />
                  ))
                )}
                {location.pathname !== "/Code-Assist" &&
                location.pathname !== "/Auditor-CodeAssist-Screen" ? (
                  <div className="codingscreen-btns-wrapper">
                    <Box sx={{ width: "100%" }}>
                      <Tooltip
                        title={
                          shouldDisableForReview
                            && "Please regroup again to perform any further actions"
                        }
                        arrow
                        disableHoverListener={
                          !shouldDisableForReview 
                        }
                      >
                        <span>
                          <button
                            onClick={handleConfirmDrg}

                            className={`confirm-drg-code w-100 ${
                              hasDenyConfirmation||
                              isActionRestricted ||
                              isLockedCoder ||
                              hasPrincipalError ||
                              
                              drgConfirmedStatusUpdate ||
                              shouldDisableForReview ||
                              allSectionsEmpty||
                              (codingscreendata?.data?.additional_diagnoses
                                ?.length === 0 &&
                                newlyInsertedCodes.length === 0 &&
                                codingscreendata?.data?.principal_diagnosis?.[0]
                                  ?.code === null &&
                                codingscreendata?.data?.procedure_codes
                                  ?.length === 0) ||
                              drgloading   ||
                              (hasStatus(
                                codingscreendata?.data?.meta?.status,
                                "Coding Complete",
                              ) &&
                                newlyInsertedCodes.length === 0 &&
                                deletedCodes.length === 0 && !hasCofOrClusterChanged) ||
                              (hasStatus(
                                codingscreendata?.data?.meta?.status,
                                "Audited",
                              ) &&
                                newlyInsertedCodes.length === 0 &&
                                deletedCodes.length === 0 && !hasCofOrClusterChanged) ||
                              (hasStatus(
                                codingscreendata?.data?.meta?.status,
                                "Audit - Awaiting Audit",
                              ) &&
                                newlyInsertedCodes.length === 0 &&
                                deletedCodes.length === 0 && !hasCofOrClusterChanged) ||
                              (hasStatus(
                                codingscreendata?.data?.meta?.status,
                                "Awaiting Audit",
                              ) &&
                                newlyInsertedCodes.length === 0 &&
                                deletedCodes.length === 0 && !hasCofOrClusterChanged) ||
                              clusterCodeWarningsIsLoading
                                ? "disabled"
                                : isButtonEnabled || allOriginsAreU
                                  ? "enabled"
                                  : "disabled"
                            }`}
                            disabled={
                              hasDenyConfirmation||
                              codeBookLoading ||
                              (selectedCodebookVersion === "12th" &&
                                !isFetched12) ||
                              (selectedCodebookVersion === "13th" &&
                                !isFetched13) ||
                              isLockedCoder ||
                              hasPrincipalError ||
                              shouldDisableForReview ||
                            
                              allSectionsEmpty  ||
                              (codingscreendata?.data?.additional_diagnoses
                                ?.length === 0 &&
                                newlyInsertedCodes.length === 0 &&
                                codingscreendata?.data?.principal_diagnosis?.[0]
                                  ?.code === null &&
                                codingscreendata?.data?.procedure_codes
                                  ?.length === 0) ||
                              isActionRestricted ||
                              (drgloading
                                ? true
                                : isDrgConfirmed ||
                                  !(isButtonEnabled || allOriginsAreU)) ||
                              (hasStatus(
                                codingscreendata?.data?.meta?.status,
                                "Coding Complete",
                              ) &&
                                newlyInsertedCodes.length === 0 &&
                                deletedCodes.length === 0 && !hasCofOrClusterChanged) ||
                              (hasStatus(
                                codingscreendata?.data?.meta?.status,
                                "Audited",
                              ) &&
                                newlyInsertedCodes.length === 0 &&
                                deletedCodes.length === 0 && !hasCofOrClusterChanged) ||
                              (hasStatus(
                                codingscreendata?.data?.meta?.status,
                                "Audit - Awaiting Audit",
                              ) &&
                                newlyInsertedCodes.length === 0 &&
                                deletedCodes.length === 0 && !hasCofOrClusterChanged) ||
                              (hasStatus(
                                codingscreendata?.data?.meta?.status,
                                "Awaiting Audit",
                              ) &&
                                newlyInsertedCodes.length === 0 &&
                                deletedCodes.length === 0 && !hasCofOrClusterChanged)
                            }
                          >
                            {clusterCodeWarningsIsLoading
                              ? "Please wait..."
                              : drgConfirmedStatusUpdate
                                ? "Confirming..."
                                : typeOfPatient === "outPatient"
                                  ? "Save"
                                  : "Confirm DRG"}
                            <img
                              src={confirm_tick}
                              alt="confirm"
                              style={{ paddingLeft: "8px", width: "18px" }}
                            />
                          </button>
                        </span>
                      </Tooltip>
                    </Box>
                    {/* <button className="generate-cdq w-100">
                    Generate CDQ{" "}
                    <img
                      src={generate_cdq}
                      alt="generate"
                      style={{ paddingLeft: "8px", width: "14px" }}
                    />
                  </button> */}
                    <button
                      className="code-assist w-100"
                      onClick={() => {
                        if (location.pathname === "/Auditor-Coding-Screen") {
                          navigate("/Auditor-CodeAssist-Screen", {
                            state: { fromAccelerate: true,
                              ...location.state,
      line_assignment_id: Number(
        sessionStorage.getItem("line_assignment_id")
      ),
                             },
                          });
                        } else {
                          navigate("/Code-Assist", {
                            state: { fromAccelerate: true ,
                              ...location.state,
      line_assignment_id: Number(
        sessionStorage.getItem("line_assignment_id")
      ),
                            },
                          });
                        }
                      }}
                    >
                      Code Assist
                      <img
                        src={code_assist}
                        alt="assist"
                        style={{ paddingLeft: "8px", width: "20px" }}
                      />
                    </button>
                  </div>
                ) : (
                  <div className="codeassist-btn-wrapper">
                    {isFromAccelerate ? (
                      <button
                        onClick={() => {
                          toast.success("Codes are added");
                          if (location.pathname === "/Auditor-Coding-Screen") {
                            navigate("/Auditor-Coding-Screen", {
                              state: { fromAccelerate: true,
                                 ...location.state,
                                     line_assignment_id: Number(
                                    sessionStorage.getItem("line_assignment_id")
                                   ),
                               },
                            });
                          } else if (
                            location.pathname === "/Auditor-CodeAssist-Screen"
                          ) {
                            navigate("/Auditor-Coding-Screen", {
                              state: { fromAccelerate: true,
                                 ...location.state,
                                   line_assignment_id: Number(
                                   sessionStorage.getItem("line_assignment_id")
                                 ),
                               },
                            });
                          } else if (location.pathname === "/Code-Assist") {
                            navigate("/coder", {
                              state: { fromAccelerate: true,
                                 ...location.state,
                                   line_assignment_id: Number(
                                  sessionStorage.getItem("line_assignment_id")
                                 ),
                               },
                            });
                          } else {
                            navigate("/coder", {
                              state: { fromAccelerate: true,
                                 ...location.state,
                               line_assignment_id: Number(
                               sessionStorage.getItem("line_assignment_id")
                              ),
                               },
                            });
                          }
                        }}
                        className="codeassist-finalise"
                        disabled={enableFinalize || isLockedCoder}
                      >
                        Finalize
                        <img
                          src={confirm_tick}
                          alt="confirm"
                          style={{ paddingLeft: "8px", width: "18px" }}
                        />
                      </button>
                    ) : (
                      <div className="codingscreen-btns-wrapper">
                        <Box sx={{ mr: { lg: 2, md: 2, sm: 2 } }}>
                          <Tooltip
                            title={
                              shouldDisableForReview
                                && "Please regroup again to perform any further actions"
                            }
                            arrow
                            disableHoverListener={
                              !shouldDisableForReview
                            }
                          >
                            <span>
                              <button
                                   onClick={() => {
                                     handleConfirmDrg();
                                     setShowMyActionsDropdown(false);
                                    }}
                                className={`confirm-drg-code w-100 ${
                                  hasDenyConfirmation||
                                  isActionRestricted ||
                                  isLockedCoder ||
                                  hasPrincipalError ||
                                  drgConfirmedStatusUpdate ||
                                  shouldDisableForReview ||
                                  allSectionsEmpty||
                                  (codingscreendata?.data?.additional_diagnoses
                                    ?.length === 0 &&
                                    newlyInsertedCodes.length === 0 &&
                                    codingscreendata?.data
                                      ?.principal_diagnosis?.[0]?.code ===
                                      null &&
                                    codingscreendata?.data?.procedure_codes
                                      ?.length === 0) ||
                                  drgloading  ||
                                  (hasStatus(
                                    codingscreendata?.data?.meta?.status,
                                    "Coding Complete",
                                  ) &&
                                    newlyInsertedCodes.length === 0 &&
                                    deletedCodes.length === 0) ||
                                  (hasStatus(
                                    codingscreendata?.data?.meta?.status,
                                    "Audited",
                                  ) &&
                                    newlyInsertedCodes.length === 0 &&
                                    deletedCodes.length === 0) ||
                                  (hasStatus(
                                    codingscreendata?.data?.meta?.status,
                                    "Audit - Awaiting Audit",
                                  ) &&
                                    newlyInsertedCodes.length === 0 &&
                                    deletedCodes.length === 0) ||
                                  (hasStatus(
                                    codingscreendata?.data?.meta?.status,
                                    "Awaiting Audit",
                                  ) &&
                                    newlyInsertedCodes.length === 0 &&
                                    deletedCodes.length === 0) ||
                                  clusterCodeWarningsIsLoading
                                    ? "disabled"
                                    : isButtonEnabled || allOriginsAreU
                                      ? "enabled"
                                      : "disabled"
                                }`}
                                disabled={
                                  hasDenyConfirmation||
                                  codeBookLoading ||
                                  (selectedCodebookVersion === "12th" &&
                                    !isFetched12) ||
                                  (selectedCodebookVersion === "13th" &&
                                    !isFetched13) ||
                                  isLockedCoder ||
                                  hasPrincipalError ||
                                  
                                  allSectionsEmpty||
                                  shouldDisableForReview ||
                                  (codingscreendata?.data?.additional_diagnoses
                                    ?.length === 0 &&
                                    newlyInsertedCodes.length === 0 &&
                                    codingscreendata?.data
                                      ?.principal_diagnosis?.[0]?.code ===
                                      null &&
                                    codingscreendata?.data?.procedure_codes
                                      ?.length === 0) ||
                                  isActionRestricted ||
                                  (drgloading
                                    ? true
                                    : isDrgConfirmed ||
                                      !(isButtonEnabled || allOriginsAreU)) ||
                                  (hasStatus(
                                    codingscreendata?.data?.meta?.status,
                                    "Coding Complete",
                                  ) &&
                                    newlyInsertedCodes.length === 0 &&
                                    deletedCodes.length === 0) ||
                                  (hasStatus(
                                    codingscreendata?.data?.meta?.status,
                                    "Audited",
                                  ) &&
                                    newlyInsertedCodes.length === 0 &&
                                    deletedCodes.length === 0) ||
                                  (hasStatus(
                                    codingscreendata?.data?.meta?.status,
                                    "Audit - Awaiting Audit",
                                  ) &&
                                    newlyInsertedCodes.length === 0 &&
                                    deletedCodes.length === 0) ||
                                  (hasStatus(
                                    codingscreendata?.data?.meta?.status,
                                    "Awaiting Audit",
                                  ) &&
                                    newlyInsertedCodes.length === 0 &&
                                    deletedCodes.length === 0)
                                }
                              >
                                {clusterCodeWarningsIsLoading
                                  ? "Please wait..."
                                  : drgConfirmedStatusUpdate
                                    ? "Confirming..."
                                    : typeOfPatient === "outPatient"
                                      ? "Save"
                                      : "Confirm DRG"}
                                <img
                                  src={confirm_tick}
                                  alt="confirm"
                                  style={{ paddingLeft: "8px", width: "18px" }}
                                />
                              </button>
                            </span>
                          </Tooltip>
                        </Box>
                        {/* <button className="generate-cdq w-100">
                    Generate CDQ{" "}
                    <img
                      src={generate_cdq}
                      alt="generate"
                      style={{ paddingLeft: "8px", width: "14px" }}
                    />
                  </button> */}
                        {/* <button
                          className="code-assist w-100"
                          onClick={() => {
                            if (
                              location.pathname === "/Auditor-Coding-Screen"
                            ) {
                              navigate("/Auditor-CodeAssist-Screen", {
                                state: { fromAccelerate: true },
                              });
                            } else {
                              navigate("/Code-Assist", {
                                state: { fromAccelerate: true },
                              });
                            }
                          }}
                        >
                          Code Assist
                          <img
                            src={code_assist}
                            alt="assist"
                            style={{ paddingLeft: "8px", width: "20px" }}
                          />
                        </button> */}
                      </div>
                    )}
                    <button
                      className="ai-search"
                      onClick={async () => {
                        if (codebookusaEnv && typeOfPatient === "outPatient") {
                          dispatch(setActiveTab("CPT Tabular"));
                          dispatch(setActiveIcon("Tabular"));
                        }
                        const toastId = toast.loading("Initializing search...");
                        try {
                          await fetchData1();
                          //Toast will be automatically updated or removed when fetch completes
                          toast.update(toastId, {
                            render: "You are ready",
                            type: "success",
                            isLoading: false,
                            autoClose: 1000,
                          });
                          setShowCodeSearch(true);
                        } catch (error) {
                          toast.update(toastId, {
                            render: "Search failed!",
                            type: "error",
                            isLoading: false,
                            autoClose: 3000,
                          });
                        } finally {
                          setIsLoading(false);
                        }
                      }}
                    >
                      Code Search
                      <img
                        src={code_assist_seacrh}
                        alt="search"
                        style={{ paddingLeft: "8px", width: "22px" }}
                      />
                    </button>
                    <button className="ai-search">
                      AI Assist
                      <img
                        src={stars_icon}
                        alt="magic"
                        style={{ paddingLeft: "8px", width: "22px" }}
                      />
                    </button>
                  </div>
                )}
              </div>
            </div>
            {modalVisible && (
              <WarningModal
                modalMessage={modalMessage}
                handleModalClose={handleModalClose}
                handlePopupConfirm={handlePopupConfirm}
              />
            )}
          </>
        ) : (
          <p className="m-auto">No data found</p>
        )
      }
    </>
  );
};
export default CodingScreen;
